import * as React from "react";
import { forwardRef } from "react";
const SvgRadSumFig = (props: React.SVGProps<SVGSVGElement>, ref: React.ForwardedRef<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="1em"
    fill="none"
    viewBox="0 0 29646 5225"
    ref={ref}
    {...props}
  >
    <path fill="#CBDEDC" d="M0 0h29646v5225H0z" />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.5}
      d="M14010.2 2059.66h-40.2v231.89h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.609}
      d="M14010.2 2105.02h-40.2v132.63h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.5}
      d="M14010.2 2572.22h-40.2v231.89h40.2zM14765.1 2572.22h-40.2v231.89h40.2zM14765.1 2051.96h-40.2v231.89h40.2z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={11.609}
      d="M14010.2 2617.57h-40.2v132.63h40.2z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.499}
      d="M14724.9 1979.22c0-39.31-31.9-71.22-71.2-71.22H14084c-39.3 0-71.2 31.91-71.2 71.22v896.51c0 39.31 31.9 71.22 71.2 71.22h569.7c39.3 0 71.2-31.91 71.2-71.22z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={12.501}
      d="M14682.3 2014.99c0-34.6-28.1-62.69-62.7-62.69H14118c-34.6 0-62.6 28.09-62.6 62.69v824.98c0 34.6 28 62.69 62.6 62.69h501.6c34.6 0 62.7-28.09 62.7-62.69z"
      clipRule="evenodd"
    />
    <circle cx={14367.9} cy={2494.05} r={55} fill="#257676" />
    <circle cx={14263.4} cy={2496.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle cx={14417.9} cy={2402.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle cx={14422.4} cy={2583.55} r={34} fill="#257676" fillOpacity={0.8} />
    <circle
      cx={14225.4}
      cy={2427.05}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle
      cx={14380.9}
      cy={2651.05}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle
      cx={14497.4}
      cy={2404.55}
      r={19.5}
      fill="#257676"
      fillOpacity={0.6}
    />
    <circle cx={14254.4} cy={2358.55} r={13} fill="#257676" fillOpacity={0.4} />
    <circle cx={14542.4} cy={2463.55} r={13} fill="#257676" fillOpacity={0.4} />
    <circle cx={14307.4} cy={2660.55} r={13} fill="#257676" fillOpacity={0.4} />
    <path
      fill="#257676"
      d="M14126.6 2157.55v-72.38h53.7v11.37h-41v18.82h36.3v11.48h-36.3v19.34h41.5v11.37zm67.7 0v-54.6h12.7v8.38c3.6-5.07 8.4-9.51 17-9.51 12.4 0 19.5 8.17 19.5 20.89v34.84h-12.6v-31.02c0-8.58-4.2-13.34-11.6-13.34s-12.3 4.97-12.3 13.55v30.81zm83 1.04c-7.9 0-16.2-2.69-23.2-8.17l5.6-8.48c6.1 4.45 12.2 6.72 17.9 6.72 5.4 0 8.5-2.27 8.5-5.89v-.21c0-4.14-5.8-5.69-12.2-7.65-8-2.17-17.1-5.59-17.1-15.93v-.2c0-10.45 8.6-16.76 19.5-16.76 6.9 0 14.2 2.38 20 6.21l-4.9 8.89c-5.3-3.2-10.9-5.17-15.5-5.17-4.8 0-7.6 2.38-7.6 5.38v.21c0 3.92 5.9 5.79 12.3 7.75 7.9 2.48 17 6.1 17 15.93v.2c0 11.48-8.9 17.17-20.3 17.17m58.1.21c-15.7 0-28-11.48-28-28.34v-.21c0-15.71 11-28.43 26.7-28.43 17.3 0 26.1 13.65 26.1 29.37 0 1.13-.1 2.27-.2 3.51h-40.1c1.3 9 7.5 13.86 15.7 13.86 6.2 0 10.4-2.28 14.8-6.52l7.3 6.52c-5.2 6.2-12.3 10.24-22.3 10.24m-15.6-32.37h28c-.8-7.96-5.6-14.38-13.8-14.38-7.8 0-13.1 5.8-14.2 14.38m52.9 31.12v-54.6h12.6v8.28c3.5-4.86 8.3-9.41 16.6-9.41 7.9 0 13.5 3.82 16.4 9.61 4.4-5.79 10.1-9.61 18.4-9.61 12 0 19.1 7.55 19.1 20.89v34.84h-12.5v-31.02c0-8.68-4-13.34-11.1-13.34-6.9 0-11.6 4.76-11.6 13.55v30.81h-12.6v-31.12c0-8.58-4-13.24-11-13.24s-11.7 5.17-11.7 13.55v30.81zm129.4 1.14c-9.1 0-14.8-4.55-18.6-9.61v8.47h-12.7v-75.48h12.7v29.98c4-5.68 9.6-10.23 18.6-10.23 12.8 0 25.3 10.13 25.3 28.33v.21c0 18.2-12.4 28.33-25.3 28.33m-3-10.86c8.6 0 15.6-6.72 15.6-17.47v-.21c0-10.55-7.3-17.47-15.6-17.47-8.6 0-16 7.03-16 17.47v.21c0 10.44 7.4 17.47 16 17.47m41.8 9.72v-75.48h12.7v75.48zm54 1.25c-15.7 0-28-11.48-28-28.34v-.21c0-15.71 11.1-28.43 26.7-28.43 17.4 0 26.2 13.65 26.2 29.37 0 1.13-.1 2.27-.3 3.51h-40.1c1.4 9 7.6 13.86 15.7 13.86 6.2 0 10.4-2.28 14.8-6.52l7.4 6.52c-5.3 6.2-12.3 10.24-22.4 10.24m-15.6-32.37h28c-.8-7.96-5.5-14.38-13.8-14.38-7.8 0-13 5.8-14.2 14.38m-393.3 147.08c-10.6 0-19.2-3.44-27.3-10.69l4.7-5.54c7 6.4 13.7 9.45 22.9 9.45 9.1 0 14.9-4.77 14.9-11.36v-.19c0-6.2-3.3-9.64-17.3-12.69-15.4-3.34-22.5-8.31-22.5-19.29v-.19c0-10.4 9.3-18.23 22-18.23 9.8 0 16.6 2.77 23.5 8.21l-4.4 5.82c-6.2-5.06-12.4-7.25-19.3-7.25-8.8 0-14.2 4.68-14.2 10.79v.19c0 6.3 3.3 9.92 18.1 12.98 14.9 3.34 21.8 8.68 21.8 18.9v.19c0 11.45-9.6 18.9-22.9 18.9m59.2.19c-14.5 0-25.3-11.74-25.3-25.58v-.19c0-14.03 10.8-25.78 25.3-25.78 9.4 0 15.1 3.82 19.8 8.79l-4.9 5.15c-3.9-4.1-8.2-7.44-15-7.44-10 0-17.7 8.4-17.7 19.09v.19c0 10.69 7.9 19.18 18.2 19.18 6.4 0 11.1-3.15 15.1-7.35l4.6 4.39c-4.9 5.64-10.8 9.55-20.1 9.55m32.5-61.28v-8.12h8.4v8.12zm.5 60.13v-49.35h7.3v49.35zm45.9 1.15c-13.4 0-24.6-10.4-24.6-25.68v-.19c0-14.22 9.9-25.68 23.7-25.68 14.6 0 23 11.65 23 26.06 0 1.05 0 1.53-.1 2.39h-39.1c1 10.69 8.5 16.7 17.3 16.7 6.9 0 11.5-2.76 15.6-6.96l4.6 4.1c-5 5.63-10.9 9.26-20.4 9.26m-17.1-28.54h31.7c-.7-8.88-5.8-16.8-15.7-16.8-8.7 0-15 7.25-16 16.8m52.1 27.39v-49.35h7.3v8.6c3.3-5.35 8.4-9.65 16.9-9.65 11.8 0 18.9 8.02 18.9 19.76v30.64h-7.4v-28.82c0-9.17-4.8-14.89-13.6-14.89-8.5 0-14.8 6.2-14.8 15.46v28.25zm75.3.86c-8 0-13.9-3.91-13.9-13.93v-29.78h-6.9v-6.5h6.9v-14.89h7.3v14.89h15.7v6.5h-15.7v28.82c0 6.11 3.3 8.21 8.3 8.21 2.6 0 4.6-.48 7.2-1.72v6.3c-2.6 1.44-5.4 2.1-8.9 2.1m22.3-60.99v-8.12h8.4v8.12zm.4 60.13v-49.35h7.4v49.35zm27.2 0v-42.85h-6.8v-6.4h6.8v-4.3c0-5.63 1.4-9.83 4.3-12.69 2.6-2.58 6.1-3.82 10.6-3.82 3.4 0 5.7.38 8.1 1.24v6.4c-2.7-.77-4.6-1.24-7.1-1.24-5.8 0-8.6 3.53-8.6 10.5v4.01h15.6v6.3h-15.5v42.85zm33 0v-49.35h7.3v49.35zm-.5-60.13v-8.12h8.4v8.12zm47.2 61.28c-14.5 0-25.3-11.74-25.3-25.58v-.19c0-14.03 10.8-25.78 25.3-25.78 9.4 0 15.1 3.82 19.8 8.79l-4.9 5.15c-3.9-4.1-8.2-7.44-15-7.44-10 0-17.7 8.4-17.7 19.09v.19c0 10.69 7.9 19.18 18.2 19.18 6.4 0 11.1-3.15 15.1-7.35l4.6 4.39c-4.9 5.64-10.8 9.55-20.1 9.55"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M14380 2952.5c0 1557.5 644.8 1557.5 1406.9 1557.5s1578.9 2.37 1578.9-1706.71c0-947.08 59.5-1660.29-440.4-1660.29-24.4 0-176.4 5.73-176.4 181"
    />
    <path fill="#3F4142" d="M13497 1799h-48v60h48z" />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13347.6 1800.64-59.3-227.09h372.6l-56 226.08z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13531 726h-115.8v47.933h115.8zM13699.8 998.695h-51.2v74.135h51.2zM13289.5 998.695h-44.1v74.135h44.1z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13167.5 962.206-.3-64.62 113.9-123.494 373.9-.158 124.1 117.244-2 71.028z"
      clipRule="evenodd"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13692.9 1534.99c0-7.1-5.8-12.85-12.9-12.85h-417c-7.1 0-12.9 5.75-12.9 12.85v25.71c0 7.09 5.8 12.85 12.9 12.85h417c7.1 0 12.9-5.76 12.9-12.85z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13739.6 1108.65c0-19.77-16.1-35.82-35.8-35.82h-466.7c-19.8 0-35.8 16.05-35.8 35.82 0 19.76 16 35.81 35.8 35.81h466.7c19.7 0 35.8-16.05 35.8-35.81M13274.3 1399.14l-100.5 123h595.4l-99.1-125.9zM13263.5 1273.24l-100.6 123h595.5l-99.2-125.89z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13274.3 1147.35-100.5 123h595.4l-99.1-125.89z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13801.2 949.93H13145v52.82h656.2z"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13619.1 773.934 119.5 128.622 5.6 47.271 34.9 1.042v-57.698L13657 773.934zM13639.3 1146l67.1 124.35h62.8l-97.5-125.89zM13632.1 1273.89l67.1 124.35h62.8l-97.5-125.89zM13639.3 1397.79l67.1 124.34h62.8l-97.5-125.89zM13627.3 1573.25l-65.5 226.39 42.8 1 54.3-225.04z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      d="M13531 726h-18.6v47.933h18.6zM13797.6 949.934h-30.8v47.933h30.8z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13274.3 1399.14-100.5 123h595.4l-99.1-125.9zm-10.8-125.9-100.6 123h595.5l-99.2-125.89zm10.8-125.89-100.5 123h595.4l-99.1-125.89zm-106.8-197.419-.3-52.346 113.9-123.494 373.8-.158 124.2 117.244-1.7 58.754h23.8v52.819h-101.4v70.08h3.9c19.8 0 35.9 16.05 35.9 35.81 0 19.77-16.1 35.82-35.9 35.82h-466.6c-19.8 0-35.8-16.05-35.8-35.82 0-19.76 16-35.81 35.8-35.81h8.3v-70.08H13145v-52.819zm122 52.819v70.08h359.1v-70.08zM13531 726h-115.8v47.933h115.8z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M13801.2 949.93H13145v52.82h656.2z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m13348.6 1800.64-59.3-227.09h372.6l-56 226.08z"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M15536 1085v-40h60v40z" />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeWidth={10}
      d="M15711 1002v126h311v-126z"
    />
    <path fill="#595959" fillOpacity={0.2} d="M15715 1099v29h307v-29z" />
    <path stroke="#3F4142" strokeWidth={10} d="M15715 1002v126h307v-126z" />
    <rect
      width={178}
      height={119}
      fill="#257676"
      stroke="#3F4142"
      strokeWidth={10}
      rx={18}
      transform="matrix(0 1 1 0 15596 976)"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      d="M15599 1111c-1.7 0-3 1.34-3 3v22c0 9.94 8.1 18 18 18h83c9.9 0 18-8.06 18-18v-22c0-1.66-1.3-3-3-3z"
    />
    <rect
      width={178}
      height={119}
      stroke="#3F4142"
      strokeWidth={10}
      rx={18}
      transform="matrix(0 1 1 0 15596 976)"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M14206 2942.39c0 132.5-732 132.5-732-1083.39M15143 3827c-278.4 0-691-317.41-691-880"
    />
    <path
      fill="#CDA024"
      fillOpacity={0.6}
      d="M15658.5 1690.5H17030l-182.5 552.5H15844z"
    />
    <path fill="#5BB3E5" d="M16160 2601h350l-26.2 75H16197z" />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeWidth={10}
      d="m15796 2301.5-200-646.5h88.5l182.5 557.5h946l182.5-557.5h88.5l-200 646.5h-1088ZM16174.8 2683l-60.8-230h26.9l55.4 198.34h287.4l55.4-198.34h26.9l-60.8 230h-330.4Z"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={50}
      d="M16169 3187c0-203.66 177-354.88 177-541"
    />
    <path
      stroke="#5BB3E5"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={40}
      d="M16169 3187c0-203.66 177-354.88 177-541"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M14525 2948.41c0 89.75 52.8 173.1 209.2 170.53 295.9-4.86 282.5-375.85 282.5-727.39 0-430.03-71.5-900.55 186.3-900.55"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M14607.5 2946.5c0 114.07 67.5 105.43 133.2 105.43 210.5 0 200.8-477.67 200.8-924.44 0-546.51-107.5-1063.49 595.5-1063.49M14261 2950c0 114.07-147.7 143-389.3 143-712.4 0-1210.7-772.5-1210.7-1598"
    />
    <path
      fill="#5BB3E5"
      d="M16329 2207h23v100h-23zM16364.9 2365.08c0 13.76-11.1 24.92-24.9 24.92s-24.9-11.16-24.9-24.92 24.9-50.67 24.9-50.67 24.9 36.91 24.9 50.67M16364.9 2489.67c0 13.76-11.1 24.91-24.9 24.91s-24.9-11.15-24.9-24.91c0-13.77 24.9-50.67 24.9-50.67s24.9 36.9 24.9 50.67"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16156 1172.43c3.3-2.48-6.1-2.27-7-2.6-5.4-1.97-10.7-5.26-14.7-8.97-4.4-4.04-5.6-11.89-7.4-18.44-.1-.64-1.1-9.43-1.7-9.01-.6.36-2.1 5.41-2.3 6.13-1 2.53-7.2 20.32-11.1 21.74-2 .72-3.7-1.09-4.9-1.76-5-2.84-6.7-15.84-14.7-13.72-2.8.73-2.5 12.14-7.3 12.26-5.7.13-9.4-6.45-12.5-9.92-1.1-1.29-3.3-3.92-6.1-2.07-4 2.67-.2 13.75-6.9 14.73-5.8.84-8.1-4.8-11.7-7.21-1.3-.86-3.7-3.06-6.3-1.28-3.7 2.48-4.2 15.95-6.2 19.31-4.5 8.08-13 4.15-18.8 11.4-2.7 3.4 3 9.16-.5 12.45-4.3 3.93-17.6 7.33-19.3 13.65-.5 2.09 1.8 2.66 2.5 3.82 1.4 2.76 2.1 6.47 3 9.76.9 3.53-4.1 7.49-5.8 11.23-1.7 3.92 2.6 7.85 4.4 8.78 3.6 1.82 12.6-5.39 14.9-2.35 4.4 6.02-4.8 21.72 7 19.66 6.6-1.14 12.5-7.54 18.6-13.95 2.4-2.52 8.1-9.05 10.9-8.8 5.2.47-3.5 18 4.8 15.74 9.6-2.62 16.2-16.08 20.7-25.26 1.5-2.88 3.9-9.62 7.2-11.63 6.1-3.78 5 12.34 11 10.75 5.9-1.55 10.6-17.71 13.7-21.9 2.4-3.12 4.8-6.15 7.3-9.16 1.1-1.28 3.4 1.39 3.6 1.78 2.2 3.09 2.3 10.78 8.1 8.9 8.5-2.7 10.8-16.75 15.3-22.97 3-4.22 6.5-4.08 8.9-6.8"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16156 1172.43c3.3-2.48-6.1-2.27-7-2.6-5.4-1.97-10.7-5.26-14.7-8.97-4.4-4.04-5.6-11.89-7.4-18.44-.1-.64-1.1-9.43-1.7-9.01-.6.36-2.1 5.41-2.3 6.13-1 2.53-7.2 20.32-11.1 21.74-2 .72-3.7-1.09-4.9-1.76-5-2.84-6.7-15.84-14.7-13.72-2.8.73-2.5 12.14-7.3 12.26-5.7.13-9.4-6.45-12.5-9.92-1.1-1.29-3.3-3.92-6.1-2.07-4 2.67-.2 13.75-6.9 14.73-5.8.84-8.1-4.8-11.7-7.21-1.3-.86-3.7-3.06-6.3-1.28-3.7 2.48-4.2 15.95-6.2 19.31-4.5 8.08-13 4.15-18.8 11.4-2.7 3.4 3 9.16-.5 12.45-4.3 3.93-17.6 7.33-19.3 13.65-.5 2.09 1.8 2.66 2.5 3.82 1.4 2.76 2.1 6.47 3 9.76.9 3.53-4.1 7.49-5.8 11.23-1.7 3.92 2.6 7.85 4.4 8.78 3.6 1.82 12.6-5.39 14.9-2.35 4.4 6.02-4.8 21.72 7 19.66 6.6-1.14 12.5-7.54 18.6-13.95 2.4-2.52 8.1-9.05 10.9-8.8 5.2.47-3.5 18 4.8 15.74 9.6-2.62 16.2-16.08 20.7-25.26 1.5-2.88 3.9-9.62 7.2-11.63 6.1-3.78 5 12.34 11 10.75 5.9-1.55 10.6-17.71 13.7-21.9 2.4-3.12 4.8-6.15 7.3-9.16 1.1-1.28 3.4 1.39 3.6 1.78 2.2 3.09 2.3 10.78 8.1 8.9 8.5-2.7 10.8-16.75 15.3-22.97 3-4.22 6.5-4.08 8.9-6.8"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16147.7 1178.5c-7.9-.91-17.4 1.45-26.1 2.45-7.5.86-15.2 2.46-22.9 4.09-5.4 1.14-10.2.42-15.6 1.82-10.3 2.65-20.8 7.19-31.3 10.65-9.5 3.16-19.4 6.54-28.6 14.91-1.3 1.14-4.3 2.83-5 3.94"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16147.7 1178.5c-7.9-.91-17.4 1.45-26.1 2.45-7.5.86-15.2 2.46-22.9 4.09-5.4 1.14-10.2.42-15.6 1.82-10.3 2.65-20.8 7.19-31.3 10.65-9.5 3.16-19.4 6.54-28.6 14.91-1.3 1.14-4.3 2.83-5 3.94"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16073.9 1181.86c0-3.14.3-5.98.8-8.98.3-1.34-.5-2.08.4-3.66"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16073.9 1181.86c0-3.14.3-5.98.8-8.98.3-1.34-.5-2.08.4-3.66"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16049 1186.83c.9-5.75 1-11.2 1-16.46 0-1.37 1.3-4.52.1-4.91"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16049 1186.83c.9-5.75 1-11.2 1-16.46 0-1.37 1.3-4.52.1-4.91"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16028.2 1191.04c-1.8-2.24-1.7-8.26-2.2-11.55-.3-1.61.2-3.44-1.3-3.92"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16028.2 1191.04c-1.8-2.24-1.7-8.26-2.2-11.55-.3-1.61.2-3.44-1.3-3.92"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16103 1180.52c-1.6-.52-1.6-5.48-2.7-7.08-.3-.57-3.2-3.22-2.3-2.94"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16103 1180.52c-1.6-.52-1.6-5.48-2.7-7.08-.3-.57-3.2-3.22-2.3-2.94"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16103.1 1196.61c-1.2 2.4-4.7 10.61-4.3 11.93.2.47-2.3 4.75-1.8 4.96"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16103.1 1196.61c-1.2 2.4-4.7 10.61-4.3 11.93.2.47-2.3 4.75-1.8 4.96"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16077.2 1196.25c-.8 2.85-1.7 5.49-2.6 8.29-.8 2.55-3 5.23-3.4 7.7-.2 1.56-1.7 3.98-1.9 5.62-.1.36-1.4 2.45-.9 2.09"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16077.2 1196.25c-.8 2.85-1.7 5.49-2.6 8.29-.8 2.55-3 5.23-3.4 7.7-.2 1.56-1.7 3.98-1.9 5.62-.1.36-1.4 2.45-.9 2.09"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16057.9 1199.99c-.8 2.85-1.7 5.5-2.7 8.29-.8 2.56-3 5.24-3.4 7.7-.2 1.57-1.6 3.98-1.9 5.62 0 .36-1.3 2.46-.9 2.09"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16057.9 1199.99c-.8 2.85-1.7 5.5-2.7 8.29-.8 2.56-3 5.24-3.4 7.7-.2 1.57-1.6 3.98-1.9 5.62 0 .36-1.3 2.46-.9 2.09"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16036.7 1203.18c-1.8 5.04-4 10.99-6.1 15.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.941}
      d="M16036.7 1203.18c-1.8 5.04-4 10.99-6.1 15.68"
    />
    <path
      fill="#EC2828"
      fillRule="evenodd"
      stroke="#961110"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16440.2 1128.79c.6-9.26 5.4-24.85 18-35.54 9.2-7.88 18.6-10.05 29.7-13.27 14.7-4.23 39.3-8.45 51.4 3.47 19.4 19.14-3.3 64.83-13.2 84.69-3.7 7.32-9.1 16.55-16.6 20.49-21.1 11.21-44.7-26.53-55.4-39.81-1.7-2.07-14.5-11.86-13.9-20.03"
      clipRule="evenodd"
    />
    <path
      fill="#F37878"
      fillRule="evenodd"
      d="M16485.3 1090.41s-21.6 5.85-27.4 12.27c-6.1 6.79-9.3 28.5-9.3 28.5s8.6-15.47 14.7-22.26c2.9-3.26 22-18.51 22-18.51"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16457.7 1143.01c-1.5-3.57 5-18.59 9-14.79 3.2 3.13-.7 12.77-2.1 16.08-.7 1.77-5.5 3.57-3.7 4.27 4.5 1.82 12.6-12.99 17-6.48 2.8 4.07-9.8 14.44-9.7 14.58.4.44-.4.84-.1.74 6.7-2.31 27.9-6.85 28.7-2.83 1.4 6.49-10.5 10.6-14.6 11.72-.6.17-11-2.94-10.8-2.31 1.7 3.9 29.3 8.01 27.8 18.87-.5 3.82-8.9 5.52-11.7 4.69-.2-.07-14.9-15.49-14.8-14.18.4 4.82 27.8 25.35 14.1 32.47-7.3 3.76-12.1-15.47-12.7-20.97-.3-2.62-4.1-10-4.1-10s-7 23.83-9.8 17.27c-1.8-4.32 1.5-14.52 3.6-18.5 1.3-2.64 6.5-6.91 3.8-8-.3-.12-8.7 5.71-10.7 6-2.7.38-5.4-.66-8-.27-2 .29-14.4 3.25-11.2-2.19 1.6-2.5 22.4-9.81 22.3-10.1-.3-.59-4.6.31-5.1.31-4.6-.02-10.3-.93-14.4-3.08-1.3-.65-11.5-5.88-9-8.11 3.2-2.85 18.6 1.41 19.1-1.58 1.5-11-19.9-4.75-13.8-15.41 8.5-14.83 12.8 12.51 20.9 11.8"
      clipRule="evenodd"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16496.2 1164.88c2.4-1.63 3.7-3.63 5.7-5.65Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.258}
      d="M16496.2 1164.88c2.4-1.63 3.7-3.63 5.7-5.65"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16506.5 1173.15c2-1.36 3.1-3.03 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16506.5 1173.15c2-1.36 3.1-3.03 4.8-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16513.1 1159.32c2-1.37 3.1-3.04 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16513.1 1159.32c2-1.37 3.1-3.04 4.8-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16503.4 1141.18c2-1.37 3-3.04 4.7-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16503.4 1141.18c2-1.37 3-3.04 4.7-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16482.3 1136.08c2-1.37 3.1-3.04 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16482.3 1136.08c2-1.37 3.1-3.04 4.8-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16489.4 1118.38c2-1.37 3-3.04 4.7-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16489.4 1118.38c2-1.37 3-3.04 4.7-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16509.2 1112.06c2-1.37 3.1-3.04 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16509.2 1112.06c2-1.37 3.1-3.04 4.8-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16524.1 1128.95c2.1-1.36 3.1-3.03 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16524.1 1128.95c2.1-1.36 3.1-3.03 4.8-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16475.5 1105.22c2-1.37 3.1-3.04 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16475.5 1105.22c2-1.37 3.1-3.04 4.8-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16472 1121.26c2-1.37 3-3.04 4.7-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16472 1121.26c2-1.37 3-3.04 4.7-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16452.6 1113.11c2.1-1.37 3.1-3.04 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16452.6 1113.11c2.1-1.37 3.1-3.04 4.8-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16509.7 1097.37c2-1.37 3.1-3.04 4.7-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16509.7 1097.37c2-1.37 3.1-3.04 4.7-4.73"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16526.3 1107.32c2-1.37 3.1-3.04 4.8-4.73Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.263}
      d="M16526.3 1107.32c2-1.37 3.1-3.04 4.8-4.73"
    />
    <path
      fill="#E6EC78"
      fillRule="evenodd"
      d="M16493.8 1093.58c2.4-1.63 3.7-3.63 5.7-5.65Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.258}
      d="M16493.8 1093.58c2.4-1.63 3.7-3.63 5.7-5.65"
    />
    <path
      fill="#EC2828"
      fillRule="evenodd"
      stroke="#961110"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.926}
      d="M16578.2 1191.46c7.3-2.64 20.6-3.91 32.6 3.31 8.9 5.33 13.4 12.73 19.3 21.34 7.7 11.3 18.4 31.32 13 46-8.7 23.57-50.6 19.66-68.8 17.95-6.7-.63-15.4-2.18-20.7-7.28-15-14.52 6.6-48.26 13.5-62.22 1.1-2.18 4.6-16.78 11.1-19.1"
      clipRule="evenodd"
    />
    <path
      fill="#F37878"
      fillRule="evenodd"
      d="M16621.3 1217.41s-11.1-16.79-17.8-19.58c-7-2.96-24.6 1.82-24.6 1.82s14.5 2.05 21.5 5.02c3.4 1.42 20.9 12.74 20.9 12.74"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.926}
      d="M16572.7 1211.73c2.2-2.55 15.7-2.13 14 2.65-1.4 3.94-10 3.82-12.9 3.82-1.6 0-4.4-3.56-4.4-1.8 0 4.62 13.8 6.49 10.1 12.62-2.2 3.83-14-3.58-14.1-3.42-.2.5-.7-.01-.6.21 3.9 5.04 13.8 21.92 11 24.04-4.6 3.43-11.3-5.48-13.4-8.65-.4-.48-1.2-10.66-1.6-10.21-2.5 2.8 2.8 28.29-5.9 30.76-3.1.87-7-5.84-7.2-8.58 0-.22 7.3-18.32 6.4-17.78-3.6 2.01-10.9 33.06-20.6 23.55-5.1-5.04 8.1-15.97 12.2-18.39 1.9-1.15 6.4-7.04 6.4-7.04s-20.4 2.23-16.2-2.47c2.7-3.1 11.5-3.77 15.2-3.39 2.4.25 7.3 3.32 7.3.57 0-.32-7-5.64-7.9-7.28-1.1-2.17-1.1-4.87-2.2-7.06-.8-1.63-6.9-11.43-1.7-10.46 2.3.45 14.3 16.07 14.5 15.86.3-.42-1.6-3.84-1.8-4.32-1.4-4.03-2.4-9.28-2.1-13.63.2-1.32 1-12.05 3.5-10.67 3.1 1.78 4.6 16.76 7 16.08 8.9-2.5-2.4-18.97 7.6-17.36 13.9 2.25-5.6 15.54-2.6 22.35"
      clipRule="evenodd"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16567.7 1252.86c2 1.53 3.9 1.94 6 2.99Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M16567.7 1252.86c2 1.53 3.9 1.94 6 2.99"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16564.5 1264.7c1.7 1.29 3.3 1.64 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16564.5 1264.7c1.7 1.29 3.3 1.64 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16577.1 1265.64c1.7 1.29 3.3 1.64 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16577.1 1265.64c1.7 1.29 3.3 1.64 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16588 1250.85c1.7 1.29 3.3 1.64 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16588 1250.85c1.7 1.29 3.3 1.64 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16585.5 1230.71c1.6 1.29 3.2 1.64 5 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16585.5 1230.71c1.6 1.29 3.2 1.64 5 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16601.1 1230.71c1.7 1.29 3.3 1.64 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16601.1 1230.71c1.7 1.29 3.3 1.64 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16612 1245.82c1.7 1.29 3.3 1.63 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16612 1245.82c1.7 1.29 3.3 1.63 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16603.7 1264.7c1.6 1.29 3.2 1.64 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16603.7 1264.7c1.6 1.29 3.2 1.64 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16607 1214.02c1.6 1.29 3.2 1.64 5 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16607 1214.02c1.6 1.29 3.2 1.64 5 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16593.6 1216.54c1.7 1.29 3.3 1.64 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16593.6 1216.54c1.7 1.29 3.3 1.64 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16594 1196.86c1.6 1.29 3.2 1.64 5 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16594 1196.86c1.6 1.29 3.2 1.64 5 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16623.4 1241.09c1.7 1.29 3.3 1.64 5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16623.4 1241.09c1.7 1.29 3.3 1.64 5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16620.9 1259.04c1.6 1.28 3.2 1.63 5 2.51Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M16620.9 1259.04c1.6 1.28 3.2 1.63 5 2.51"
    />
    <path
      fill="#E6EC78"
      fillRule="evenodd"
      d="M16621.5 1225.98c1.9 1.53 3.9 1.94 6 2.99Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M16621.5 1225.98c1.9 1.53 3.9 1.94 6 2.99"
    />
    <path
      fill="#EC2828"
      fillRule="evenodd"
      stroke="#961110"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.926}
      d="M15936.7 1277.71c-7.3-2.64-20.6-3.91-32.6 3.31-8.9 5.33-13.4 12.73-19.3 21.34-7.7 11.3-18.4 31.32-13 46 8.7 23.57 50.6 19.66 68.8 17.95 6.7-.63 15.4-2.18 20.7-7.28 15-14.52-6.6-48.26-13.5-62.22-1.1-2.18-4.6-16.78-11.1-19.1"
      clipRule="evenodd"
    />
    <path
      fill="#F37878"
      fillRule="evenodd"
      d="M15893.6 1303.67s11.1-16.79 17.7-19.59c7.1-2.96 24.7 1.82 24.7 1.82s-14.5 2.06-21.5 5.02c-3.4 1.42-20.9 12.75-20.9 12.75"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.926}
      d="M15942.2 1297.98c-2.2-2.55-15.7-2.13-14 2.65 1.4 3.94 10 3.82 12.9 3.82 1.6 0 4.4-3.56 4.4-1.8 0 4.62-13.8 6.49-10.1 12.62 2.2 3.83 14-3.58 14.1-3.42.2.5.7-.01.6.21-3.9 5.04-13.8 21.92-11 24.04 4.6 3.43 11.3-5.48 13.4-8.65.4-.48 1.2-10.66 1.6-10.21 2.5 2.8-2.8 28.29 5.9 30.76 3.1.87 7-5.84 7.2-8.58 0-.22-7.3-18.32-6.4-17.78 3.6 2.01 10.9 33.06 20.6 23.55 5.1-5.04-8.1-15.97-12.2-18.39-1.9-1.15-6.4-7.04-6.4-7.04s20.4 2.23 16.2-2.47c-2.7-3.1-11.5-3.77-15.2-3.39-2.4.25-7.3 3.32-7.3.57 0-.32 7-5.64 7.9-7.28 1.1-2.17 1.1-4.87 2.2-7.06.8-1.63 6.9-11.43 1.7-10.46-2.3.45-14.3 16.07-14.5 15.86-.4-.42 1.6-3.84 1.8-4.32 1.4-4.03 2.4-9.28 2.1-13.63-.2-1.32-1-12.05-3.5-10.67-3.1 1.78-4.6 16.76-7 16.08-8.9-2.5 2.4-18.97-7.6-17.36-13.9 2.25 5.6 15.54 2.6 22.35"
      clipRule="evenodd"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15947.2 1339.12c-2 1.53-3.9 1.94-6.1 2.98Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15947.2 1339.12c-2 1.53-3.9 1.94-6.1 2.98"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15950.4 1350.96c-1.7 1.29-3.3 1.64-5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15950.4 1350.96c-1.7 1.29-3.3 1.64-5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15937.8 1351.9c-1.7 1.29-3.3 1.64-5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15937.8 1351.9c-1.7 1.29-3.3 1.64-5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15926.9 1337.11c-1.7 1.28-3.3 1.63-5.1 2.51Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15926.9 1337.11c-1.7 1.28-3.3 1.63-5.1 2.51"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15929.4 1316.96c-1.6 1.29-3.2 1.64-5 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15929.4 1316.96c-1.6 1.29-3.2 1.64-5 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15913.7 1316.96c-1.6 1.29-3.2 1.64-5 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15913.7 1316.96c-1.6 1.29-3.2 1.64-5 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15902.9 1332.07c-1.7 1.29-3.3 1.64-5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15902.9 1332.07c-1.7 1.29-3.3 1.64-5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15911.2 1350.96c-1.6 1.29-3.3 1.64-5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15911.2 1350.96c-1.6 1.29-3.3 1.64-5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15907.9 1300.28c-1.6 1.29-3.2 1.64-5 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15907.9 1300.28c-1.6 1.29-3.2 1.64-5 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15921.3 1302.79c-1.7 1.29-3.3 1.64-5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15921.3 1302.79c-1.7 1.29-3.3 1.64-5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15945.3 1203.63c.2 1.54.9 2.74 1.4 4.26Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15945.3 1203.63c.2 1.54.9 2.74 1.4 4.26"
    />
    <path
      fill="#EC2828"
      fillRule="evenodd"
      stroke="#961110"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.935}
      d="M16015.6 1210.95c-2.6-6.06-9.3-16.03-19.3-22.25-7.5-4.59-13.5-5.4-20.9-6.8-9.7-1.82-25.4-2.99-29.6 5.65-6.7 13.89 18 42.51 28.7 54.95 4 4.59 9.5 10.31 14.8 12.42 15.3 6 20-20.41 23.1-29.87.4-1.47 5.6-8.76 3.2-14.1"
      clipRule="evenodd"
    />
    <path
      fill="#F37878"
      fillRule="evenodd"
      d="M15985.3 1190.64s16.5-1.87 20.6 1.01c4.4 3.05 5.7 17.29 5.7 17.29s-5.8-8.42-10.2-11.47c-2.1-1.46-16.1-6.83-16.1-6.83"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.935}
      d="M16005.2 1217.55c0-2.51-7.8-12.22-9.3-9.39-1.2 2.34 3.7 8.58 5.4 10.73.9 1.15 4.3 2.04 3.4 2.63-2.3 1.55-11.1-7.93-12.2-3.23-.6 2.94 9.8 9.1 9.8 9.2-.1.33.4.54.2.5-4.7-1.11-19-2.76-18.4.01.8 4.48 9.2 6.46 12 6.95.4.07 6.1-2.73 6.1-2.29-.1 2.75-16 7.38-12.3 14.62 1.3 2.54 6.9 3.13 8.4 2.38.1-.06 5.2-11.47 5.5-10.57 1 3.28-10.7 19-.4 22.89 5.5 2.05 3.6-11.27 2.5-15.03-.5-1.79 0-7.03 0-7.03s10.4 15.64 10.4 11.02c0-3.05-4.7-9.72-6.9-12.28-1.5-1.69-5.8-4.22-4.5-5.14.2-.11 6.9 3.27 8.2 3.33 1.8.08 3.1-.8 4.9-.72 1.3.06 9.7 1.23 6.3-2.22-1.6-1.59-16.3-5.14-16.3-5.34 0-.42 2.8-.09 3.2-.13 2.8-.33 6.1-1.32 8.1-3.05.6-.53 5.6-4.75 3.5-6.09-2.7-1.71-11.2 2.2-12.2.22-3.8-7.34 11-4.55 4.5-11.35-9-9.45-4.7 9.32-9.9 9.38"
      clipRule="evenodd"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15985.2 1237.88c-1.7-.88-2.8-2.06-4.4-3.21Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15985.2 1237.88c-1.7-.88-2.8-2.06-4.4-3.21"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15979.1 1244.65c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15979.1 1244.65c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15973.3 1236.99c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15973.3 1236.99c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15978.1 1224.05c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15978.1 1224.05c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15991.7 1217.54c-1.4-.74-2.3-1.72-3.6-2.69Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15991.7 1217.54c-1.4-.74-2.3-1.72-3.6-2.69"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15985.3 1207.52c-1.5-.74-2.4-1.73-3.7-2.69Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15985.3 1207.52c-1.5-.74-2.4-1.73-3.7-2.69"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15971.3 1206.66c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15971.3 1206.66c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15962.9 1219.63c-1.4-.73-2.3-1.72-3.6-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15962.9 1219.63c-1.4-.73-2.3-1.72-3.6-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15993.3 1197.06c-1.4-.74-2.4-1.72-3.7-2.69Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15993.3 1197.06c-1.4-.74-2.4-1.72-3.7-2.69"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15997.2 1206.59c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15997.2 1206.59c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M16009.4 1198.43c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M16009.4 1198.43c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15969.6 1197.49c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15969.6 1197.49c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15959.4 1206.36c-1.4-.73-2.4-1.72-3.7-2.68Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15959.4 1206.36c-1.4-.73-2.4-1.72-3.7-2.68"
    />
    <path
      fill="#E6EC78"
      fillRule="evenodd"
      d="M15979.8 1192.67c-1.6-.88-2.8-2.06-4.3-3.21Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15979.8 1192.67c-1.6-.88-2.8-2.06-4.3-3.21"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15891.5 1327.35c-1.7 1.29-3.3 1.64-5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15891.5 1327.35c-1.7 1.29-3.3 1.64-5.1 2.52"
    />
    <path
      fill="#EEF1C1"
      fillRule="evenodd"
      d="M15894 1345.29c-1.6 1.29-3.2 1.64-5.1 2.52Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.257}
      d="M15894 1345.29c-1.6 1.29-3.2 1.64-5.1 2.52"
    />
    <path
      fill="#E6EC78"
      fillRule="evenodd"
      d="M15893.4 1312.23c-2 1.53-3.9 1.95-6 2.99Z"
      clipRule="evenodd"
    />
    <path
      stroke="#EEF1C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={3.264}
      d="M15893.4 1312.23c-2 1.53-3.9 1.95-6 2.99"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16363.1 1577.47c0-6.69 20.3-1.59 23.6-.73 22.7 6.02 46.7 20.9 66 2.97 0-.01-4.1-1.06-4.7-1.17-3-.55-8.9-.86-10.4-3.69-1-1.9 5.5-3.06 3.6-5.5-3.5-4.31-6.8 1.05-11.2-1.36-2.4-1.34-.7-5.98-4.6-8.02-3.3-1.76-6.3 1.93-8.2.54-2.3-1.71-1.7-5.82-5.2-6.28-3.1-.41-4.4 3.34-7 3.94-2.1.49-2.8-4.43-5-4.71-3.9-.52-3.9 4.56-6.7 5.2-2.5.59-4.1-3.2-6.5-2.63-10.1 2.34-18.1 17.05-27.6 21.44"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.94}
      d="M16363.1 1577.47c0-6.69 20.3-1.59 23.6-.73 22.7 6.02 46.7 20.9 66 2.97 0-.01-4.1-1.06-4.7-1.17-3-.55-8.9-.86-10.4-3.69-1-1.9 5.5-3.06 3.6-5.5-3.5-4.31-6.8 1.05-11.2-1.36-2.4-1.34-.7-5.98-4.6-8.02-3.3-1.76-6.3 1.93-8.2.54-2.3-1.71-1.7-5.82-5.2-6.28-3.1-.41-4.4 3.34-7 3.94-2.1.49-2.8-4.43-5-4.71-3.9-.52-3.9 4.56-6.7 5.2-2.5.59-4.1-3.2-6.5-2.63-10.1 2.34-18.1 17.05-27.6 21.44"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16287.9 1344.36c-5.6-3.69 9.9-17.8 12.4-20.04 17.5-15.63 43.2-27.4 38.9-53.43 0-.01-3.2 2.86-3.6 3.3-2.1 2.17-5.6 6.91-8.8 6.62-2.1-.2.5-6.31-2.6-6.01-5.5.53-2.9 6.23-7.3 8.52-2.4 1.27-5.4-2.66-9.2-.58-3.3 1.79-1.9 6.32-4.1 7.12-2.7.97-5.8-1.77-8.1.87-2.1 2.39.4 5.54-.6 8.03-.7 2.01-5.2-.08-6.7 1.55-2.6 2.98 1.7 5.81.7 8.47-.9 2.46-4.9 1.63-5.8 4.02-3.7 9.68 4.2 24.48 2.6 34.8"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.94}
      d="M16287.9 1344.36c-5.6-3.69 9.9-17.8 12.4-20.04 17.5-15.63 43.2-27.4 38.9-53.43 0-.01-3.2 2.86-3.6 3.3-2.1 2.17-5.6 6.91-8.8 6.62-2.1-.2.5-6.31-2.6-6.01-5.5.53-2.9 6.23-7.3 8.52-2.4 1.27-5.4-2.66-9.2-.58-3.3 1.79-1.9 6.32-4.1 7.12-2.7.97-5.8-1.77-8.1.87-2.1 2.39.4 5.54-.6 8.03-.7 2.01-5.2-.08-6.7 1.55-2.6 2.98 1.7 5.81.7 8.47-.9 2.46-4.9 1.63-5.8 4.02-3.7 9.68 4.2 24.48 2.6 34.8"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16313.1 1437.32c1.7-3.58-14.6-11.23-17.1-11.56-15.6-2.06-31.7 4.22-46.8-.66-3.7-1.21-12-6.1-11.7-11.83.1-1.07 12.5-3.03 14.2-4.75 1.5-1.41-2.6-2.71-2.5-4.74.1-1.36 2.7-3.87 3.7-4.61 8.6-6.3 12.4 2.15 19.5 2.34 2 .05 4.3-6.65 7.5-6.79 4.1-.18 5.5 6.43 8.3 6.76 2.3.28 3.9-3.59 6.3-3.53 4.8.13.7 7.62 1.7 9.84 1.1 2.36 5.1-1.86 6.7.16 1.5 1.86-.6 7.15 0 9.63 1.4 5.9 17 13.06 11.3 20.89"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M16313.1 1437.32c1.7-3.58-14.6-11.23-17.1-11.56-15.6-2.06-31.7 4.22-46.8-.66-3.7-1.21-12-6.1-11.7-11.83.1-1.07 12.5-3.03 14.2-4.75 1.5-1.41-2.6-2.71-2.5-4.74.1-1.36 2.7-3.87 3.7-4.61 8.6-6.3 12.4 2.15 19.5 2.34 2 .05 4.3-6.65 7.5-6.79 4.1-.18 5.5 6.43 8.3 6.76 2.3.28 3.9-3.59 6.3-3.53 4.8.13.7 7.62 1.7 9.84 1.1 2.36 5.1-1.86 6.7.16 1.5 1.86-.6 7.15 0 9.63 1.4 5.9 17 13.06 11.3 20.89"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16195.3 1522.89c-3.9-.22-3.1-18.15-2.3-20.5 5.5-14.82 18.5-26.15 21.2-41.75.7-3.9.2-13.49-5-15.88-1-.45-8.5 9.62-10.8 10.4-2 .63-1.2-3.61-3-4.46-1.3-.56-4.7.59-5.8 1.14-9.6 4.68-3.9 11.94-7 18.34-.9 1.75-7.9.68-9.5 3.44-2.1 3.56 3.1 7.94 2.1 10.5-.9 2.24-5 1.8-6.1 3.99-2.1 4.31 6.5 4.1 8 6.06 1.5 2.07-4.1 3.65-3 6.01.9 2.18 6.6 2.77 8.5 4.46 4.6 4.01 3.7 21.11 13.3 19.69"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M16195.3 1522.89c-3.9-.22-3.1-18.15-2.3-20.5 5.5-14.82 18.5-26.15 21.2-41.75.7-3.9.2-13.49-5-15.88-1-.45-8.5 9.62-10.8 10.4-2 .63-1.2-3.61-3-4.46-1.3-.56-4.7.59-5.8 1.14-9.6 4.68-3.9 11.94-7 18.34-.9 1.75-7.9.68-9.5 3.44-2.1 3.56 3.1 7.94 2.1 10.5-.9 2.24-5 1.8-6.1 3.99-2.1 4.31 6.5 4.1 8 6.06 1.5 2.07-4.1 3.65-3 6.01.9 2.18 6.6 2.77 8.5 4.46 4.6 4.01 3.7 21.11 13.3 19.69"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.3}
      d="M16283 1697.04c8.7-2.76 11.9-20.76 14-27.73 8.4-27.72 14-55.68 19.2-84.25 16.5-90.77-1.6-208.4-60.1-291.05-15.7-22.24-33.4-45.31-53.2-64.87-11.4-11.23-29.3-22.62-37.9-35.57"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.233}
      d="M16293.1 1693.22c2.6-.69-1.4-22.65-1.8-24.53-6.6-26.66-20.5-52.41-37-76.03-36.7-52.56-96.6-107.84-162.7-136.97-26.1-11.49-53.4-21.95-81.1-30.65-13.7-4.32-29.5-6.59-42.6-11.87"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.233}
      d="M16293.6 1693.24c3.6-11.56-23-43.71-29.6-54.12-34.4-53.89-110.8-98.37-184.9-106.41-14.6-1.58-28.7-5.7-43.4-3.57"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.233}
      d="M16284.6 1695.73c12.1-.28-13.1-45.63-14.3-47.55-19.1-30.69-43.1-59.42-74.6-81.82-10.8-7.66-23.1-13.31-33.7-21.11"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.283}
      d="M16292.1 1670.74c10.2-2.6-4.8-8.13-5.3-13.67-4-43.44-9.4-87.43-19.2-129.7-17.4-74.5-35.5-121.89-102.1-169.96-26.9-19.36-54.6-34.5-89.1-42.48-40.8-9.48-84.4.04-126.3-4.94"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.233}
      d="M16065.3 1308.76c35.5 17.02-19.9-10.19-32.1-24.39-11.7-13.68-18.7-52.81-30.4-60.2M16283.1 1702.69c9.6.71 15.4-22.92 16.7-28.78 4.3-18.66 6.7-37.46 13.1-55.77 5.8-16.43 15.2-32.07 22.4-48.1 6.9-15.38 17.3-29.58 23.9-45.06 14.4-33.4 20.6-72.02 20.2-107.22-.4-44.79-22.8-93.48-8.2-137.46 10-30.08 33.9-57.88 58.5-81.47 11.1-10.6 26.6-19.73 35.5-31.54M16409.4 1213.82c9.7-5.06 3.4-20.82-.1-27.08-14.2-25.66-40.5-42.19-61.6-63.81"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.233}
      d="M16414.6 1212.55c21.9 1.42 42.7-9.18 65-8.92 26.1.3 54.9 12.78 79.2 19.9"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.244}
      d="M16288 1697.85c3.9 1.6 7.6-1 8.3-4.06 2.7-11.77 5.7-23.13 9.3-34.79 8.1-26.42 21.6-51.02 35.8-75.57 10-17.3 17.4-37.12 33.3-51.68 14-12.92 33.6-21.06 49.1-32.72 25.6-19.29 46.1-45.12 57.5-72.04"
    />
    <path
      stroke="#9DB56F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={9.279}
      d="M16300.6 1686.85c6.9-5.2 8.6-16.95 12.2-24.2 10-19.87 16.5-40.26 27.9-59.8 4.7-8.06 11.5-14.86 17.4-22.25 36.3-45.22 81.6-64.54 145.4-51.22 17.4 3.62 34.4 11.23 49.7 18.75"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16189.3 1190.15c2.7-24.95 19.1-44.78 25.1-68.78 1.2-4.46 8-14.14 6.6-18.83-.5-1.75-3.7.35-5.3 1.14-5 2.36-9.6 4.27-14.8 5.95-1.3.4-4.4 1.56-5-.64-.8-2.5.9-4.97 1.4-7.35 1.5-7.8 5.4-14.51 8.3-21.8.5-1.29 3.5-8.7 2.7-9.48-.3-.33-3.8 3.49-3.8 3.49-3.5 3.62-7.3 6.47-11.3 9.53-.6.45-3.1 3.36-3.9 1.76-1.7-3.11-.2-7.84.3-10.91 1.2-6.98.8-14.15 1.6-21.17.1-.5 3-12.91 2.2-12.92-.9-.02-2.6 3.15-3 3.6-1.5 2.06-8.5 12.6-11.7 10.94-1-.57-1.6-4.19-2-5.37-2-5.78-1-12.38-2.7-18.43-.4-1.29-.8-5.68-2.2-6.2-2-.81-2.7 2.39-3.4 3.72-1.2 2.54-7.8 14.08-11.1 12.72-2.1-.88-3.2-4.08-4.4-5.81-3.8-5.4-7.5-11.16-11.7-16.26-1-1.27-3.2-5.2-4.8-5.71-4.6-1.49-2.4 18.22-8 14.12-8.6-6.32-17.3-14.17-24.6-21.87-1.2-1.19-5.3-8.668-6.9-8.488-1.8.194-.4 6.068-.4 7.158.4 5.69.5 12.02 0 17.68-.2 1.74.1 4.89-1.4 6.06-3.5 2.73-8.8-7.13-13.6-5.02-1.4.64-1.2 3.96-1.2 5.33.3 4.06 3.3 8.63 5.1 12.32.6 1.26 2.7 3.65 1.8 5.14-1.4 2.21-5.3.65-7.5 1.09-3.6.7-11.6 5.75-11.8 9.82-.2 4.76 4.9 8.73 8.2 11.39.5.42 4.9 5.15 4.4 5.41-5.8 3.04-14.4-.38-15.6 7.98-1 6.64 8.2 13.35 13 16.72 1.7 1.17 4.9 2.44 5.7 4.58 1.2 3.27-7.4 5.52-5.1 10.67 4.3 9.33 21.7 8.93 29 14.97 3.7 3.05-5.7 7.7-3.7 11.32 3.3 6.28 14.5 3.48 16.9 9.28 1.2 3.13-4.8 6.5-3.9 10.25.6 2.55 4 2.67 6.1 3.23 6.4 1.72 13.5-1.05 19.6 2.39 5 2.86-3 10.3-1.6 13.88 1.5 3.88 14.3 3.21 17.6 3.66 6.4.88 12.5 3.56 18.5 6.12 1.9.85 3.8 1.89 5.7 2.84.4.2 2.9 1.67 2.8 1.38"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16189.3 1190.15c2.7-24.95 19.1-44.78 25.1-68.78 1.2-4.46 8-14.14 6.6-18.83-.5-1.75-3.7.35-5.3 1.14-5 2.36-9.6 4.27-14.8 5.95-1.3.4-4.4 1.56-5-.64-.8-2.5.9-4.97 1.4-7.35 1.5-7.8 5.4-14.51 8.3-21.8.5-1.29 3.5-8.7 2.7-9.48-.3-.33-3.8 3.49-3.8 3.49-3.5 3.62-7.3 6.47-11.3 9.53-.6.45-3.1 3.36-3.9 1.76-1.7-3.11-.2-7.84.3-10.91 1.2-6.98.8-14.15 1.6-21.17.1-.5 3-12.91 2.2-12.92-.9-.02-2.6 3.15-3 3.6-1.5 2.06-8.5 12.6-11.7 10.94-1-.57-1.6-4.19-2-5.37-2-5.78-1-12.38-2.7-18.43-.4-1.29-.8-5.68-2.2-6.2-2-.81-2.7 2.39-3.4 3.72-1.2 2.54-7.8 14.08-11.1 12.72-2.1-.88-3.2-4.08-4.4-5.81-3.8-5.4-7.5-11.16-11.7-16.26-1-1.27-3.2-5.2-4.8-5.71-4.6-1.49-2.4 18.22-8 14.12-8.6-6.32-17.3-14.17-24.6-21.87-1.2-1.19-5.3-8.668-6.9-8.488-1.8.194-.4 6.068-.4 7.158.4 5.69.5 12.02 0 17.68-.2 1.74.1 4.89-1.4 6.06-3.5 2.73-8.8-7.13-13.6-5.02-1.4.64-1.2 3.96-1.2 5.33.3 4.06 3.3 8.63 5.1 12.32.6 1.26 2.7 3.65 1.8 5.14-1.4 2.21-5.3.65-7.5 1.09-3.6.7-11.6 5.75-11.8 9.82-.2 4.76 4.9 8.73 8.2 11.39.5.42 4.9 5.15 4.4 5.41-5.8 3.04-14.4-.38-15.6 7.98-1 6.64 8.2 13.35 13 16.72 1.7 1.17 4.9 2.44 5.7 4.58 1.2 3.27-7.4 5.52-5.1 10.67 4.3 9.33 21.7 8.93 29 14.97 3.7 3.05-5.7 7.7-3.7 11.32 3.3 6.28 14.5 3.48 16.9 9.28 1.2 3.13-4.8 6.5-3.9 10.25.6 2.55 4 2.67 6.1 3.23 6.4 1.72 13.5-1.05 19.6 2.39 5 2.86-3 10.3-1.6 13.88 1.5 3.88 14.3 3.21 17.6 3.66 6.4.88 12.5 3.56 18.5 6.12 1.9.85 3.8 1.89 5.7 2.84.4.2 2.9 1.67 2.8 1.38"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16195.3 1186.79c-8.4-12.36-13-25.49-20.4-38.12-12.4-21.22-25.5-42.11-38-63.38-2.2-3.71-4-7.63-6-11.4-1.5-2.89-1.2-2.8-3-5.43-1.6-2.44-4.4-6.71-6.3-8.39-1-.81-2.9-.99-4.1-1.85-3.2-2.12-6.1-4.45-8.8-7.08-3.7-3.61-7.3-6.6-11-10.03-1.1-1.07-2.5-2.68-4-3.2"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16195.3 1186.79c-8.4-12.36-13-25.49-20.4-38.12-12.4-21.22-25.5-42.11-38-63.38-2.2-3.71-4-7.63-6-11.4-1.5-2.89-1.2-2.8-3-5.43-1.6-2.44-4.4-6.71-6.3-8.39-1-.81-2.9-.99-4.1-1.85-3.2-2.12-6.1-4.45-8.8-7.08-3.7-3.61-7.3-6.6-11-10.03-1.1-1.07-2.5-2.68-4-3.2"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16139.2 1094.77c-6.4-2.47-12.7-5.13-19.2-7.03-3.5-1.04-8.2-4-11.7-3.92-2.6.05-6.9-2.51-9.7-3.55"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16141.2 1111.09c-11.9-1.28-24.9.8-36.6-3.63Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16141.2 1111.09c-11.9-1.28-24.9.8-36.6-3.63M16145.5 1129c-9.6-1.12-17.8.29-27 .33-1.9 0-6.8-.93-7.8.12"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16154.3 1147.67c-5.7-.23-11.3.37-16.4 1.33-1.5.27-4.1.1-5.1.84-.2.13-2.3.33-1.7.55"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16154.3 1147.67c-5.7-.23-11.3.37-16.4 1.33-1.5.27-4.1.1-5.1.84-.2.13-2.3.33-1.7.55"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16165.9 1138.08c2.5-2.11 2.4-2.03 4.9-4.21 2.6-2.22 5.8-4.45 7.8-6.92 1-1.29 3.4-1.6 4.2-3.07.4-.74 2.2-4.1 3-3.83"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16165.9 1138.08c2.5-2.11 2.4-2.03 4.9-4.21 2.6-2.22 5.8-4.45 7.8-6.92 1-1.29 3.4-1.6 4.2-3.07.4-.74 2.2-4.1 3-3.83"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16164.2 1114.46c5.4-5.27 10.7-10.53 16-15.81 1-1.04 3.7-5.64 5.5-5.07"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16164.2 1114.46c5.4-5.27 10.7-10.53 16-15.81 1-1.04 3.7-5.64 5.5-5.07"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16156 1085.79c8.3-5.67 13.5-12.26 19.5-19.65 1.3-1.69 4.5-6.96 8-5.85"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16156 1085.79c8.3-5.67 13.5-12.26 19.5-19.65 1.3-1.69 4.5-6.96 8-5.85"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16149.1 1059.71c2.7-4.49 4.9-9.17 7.2-13.58.7-1.21.9-4.17 3.6-3.51"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.922}
      d="M16149.1 1059.71c2.7-4.49 4.9-9.17 7.2-13.58.7-1.21.9-4.17 3.6-3.51"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16162.8 1191.35c2.9 2.93 17.2.76 21.3 1.22 15.1 1.74 31.2 10.11 45 15.54 2.9 1.11 12.9 6.28 16.1 3.67 2.3-1.85-3.1-5.68-3.1-6.61-.3-3.03 3-6.31-2.9-12.1-6.5-6.35 4.6-4.95 8-3.97 9.5 2.72 14.8 6.81 25.1 5.28 2-.3 3.1-1.58 4.8-2.18.9-.29 2.8.65 2.8-.16-.2-2.3-11.1-5.57-5.6-8.99 6.7-4.16 14.2-2.35 21.5-3.46 2.8-.42 7.1-.29 8.8-2.89 3.4-5.17-11.1-6.6-5.8-11.24 6.6-5.81 20.5-.83 28.2-5.98 7-4.62-5.5-7-4.4-11.96 1.6-6.97 14.5-3.96 18-10.27 2.3-4.18-8.9-1.57-7.5-8.16.8-3.81 4.7-5.75 7.3-8.57 3-3.34 5.8-8.34 7.6-12.31.5-1.19 3.6-5.99 2.2-7.33-1.4-1.44-6 1.09-7.2 1.44-4.8 1.4-15.8 5.58-20.2 3.3-8-4.19 5-21.03-3.5-24.41-8.5-3.42-10 13.83-17.2 13.17-7-.63-3.1-15.2-11.1-15.59-7.2-.34-7.7 13.6-14.7 14.94-6.2 1.19-7.7-11.71-14.6-10.62-8.5 1.32-3.5 14.96-9.7 18.03-5 2.49-10.8-6.41-16.8-1.8-4.7 3.56.5 14.05-5.8 16.23-5.5 1.88-12.2-6.15-16.8-.03-4.5 6.08 4.1 13.61-.9 20.15-2.4 3.06-8.3-2.66-11.9-.06-6.2 4.47 1.2 13.44-2.6 17.57-1.5 1.57-5-.55-7-.27-4.1.6-9.2 3.75-11.3 7.12-4.8 7.86-.3 18.94-8.4 26.68"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16162.8 1191.35c2.9 2.93 17.2.76 21.3 1.22 15.1 1.74 31.2 10.11 45 15.54 2.9 1.11 12.9 6.28 16.1 3.67 2.3-1.85-3.1-5.68-3.1-6.61-.3-3.03 3-6.31-2.9-12.1-6.5-6.35 4.6-4.95 8-3.97 9.5 2.72 14.8 6.81 25.1 5.28 2-.3 3.1-1.58 4.8-2.18.9-.29 2.8.65 2.8-.16-.2-2.3-11.1-5.57-5.6-8.99 6.7-4.16 14.2-2.35 21.5-3.46 2.8-.42 7.1-.29 8.8-2.89 3.4-5.17-11.1-6.6-5.8-11.24 6.6-5.81 20.5-.83 28.2-5.98 7-4.62-5.5-7-4.4-11.96 1.6-6.97 14.5-3.96 18-10.27 2.3-4.18-8.9-1.57-7.5-8.16.8-3.81 4.7-5.75 7.3-8.57 3-3.34 5.8-8.34 7.6-12.31.5-1.19 3.6-5.99 2.2-7.33-1.4-1.44-6 1.09-7.2 1.44-4.8 1.4-15.8 5.58-20.2 3.3-8-4.19 5-21.03-3.5-24.41-8.5-3.42-10 13.83-17.2 13.17-7-.63-3.1-15.2-11.1-15.59-7.2-.34-7.7 13.6-14.7 14.94-6.2 1.19-7.7-11.71-14.6-10.62-8.5 1.32-3.5 14.96-9.7 18.03-5 2.49-10.8-6.41-16.8-1.8-4.7 3.56.5 14.05-5.8 16.23-5.5 1.88-12.2-6.15-16.8-.03-4.5 6.08 4.1 13.61-.9 20.15-2.4 3.06-8.3-2.66-11.9-.06-6.2 4.47 1.2 13.44-2.6 17.57-1.5 1.57-5-.55-7-.27-4.1.6-9.2 3.75-11.3 7.12-4.8 7.86-.3 18.94-8.4 26.68"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16181 1180.71c7.8-6.32 18.1-10.99 26.9-15.81 4.9-2.68 9-6.56 13.7-9.55 6.8-4.36 14.9-7.36 21.1-12.43 3.6-2.98 9.9-4.09 14.3-5.9 4.6-1.9 8.6-4.35 13-6.53 9.7-4.78 19.8-7.2 29.3-11.11 1.6-.66 7.9-2.79 8.5-4.13"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16181 1180.71c7.8-6.32 18.1-10.99 26.9-15.81 4.9-2.68 9-6.56 13.7-9.55 6.8-4.36 14.9-7.36 21.1-12.43 3.6-2.98 9.9-4.09 14.3-5.9 4.6-1.9 8.6-4.35 13-6.53 9.7-4.78 19.8-7.2 29.3-11.11 1.6-.66 7.9-2.79 8.5-4.13"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16269 1122.55c.3-3.7-.6-7.42-.3-11.15.1-.73.5-2.93 0-3.11"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16269 1122.55c.3-3.7-.6-7.42-.3-11.15.1-.73.5-2.93 0-3.11"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16244.3 1133.78c-.2-2.81-1.8-5.76-2.4-8.62-.9-4.21.6-8.94.2-12.88 0-1.16-.8-1.94-.2-3.22"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16244.3 1133.78c-.2-2.81-1.8-5.76-2.4-8.62-.9-4.21.6-8.94.2-12.88 0-1.16-.8-1.94-.2-3.22"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16221.1 1144.24c.3-3.32 1.5-7.75.2-10.54-.3-.55.5-1.82-.3-2.07"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16221.1 1144.24c.3-3.32 1.5-7.75.2-10.54-.3-.55.5-1.82-.3-2.07"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16276.2 1140.58c9.6 3.4 19.8 4.78 29.9 5.44 1.7.11 9 2.3 9.5.93"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16276.2 1140.58c9.6 3.4 19.8 4.78 29.9 5.44 1.7.11 9 2.3 9.5.93"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16254.3 1148.49c12.3 4.64 24.8 11.37 36.6 15.77Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16254.3 1148.49c12.3 4.64 24.8 11.37 36.6 15.77"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16237.3 1157.07c11.6 4.04 17.8 14.67 28.5 18.42Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.908}
      d="M16237.3 1157.07c11.6 4.04 17.8 14.67 28.5 18.42M16223.2 1168.18s3.3 3.68 6.1 5.4c2.6 1.66 7.7 3.26 7.7 3.26"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16156.3 1547.02c.4.24-.5-5.52-.4-6.67.1-5.35.4-10 1.6-15.85.6-2.51 1.9-6.12 3.2-8.71.7-1.37 2.3-5.43 1.4-4.11-.8 1.21-5.7 10.19-7.2 9.48-.7-.37 1.1-5.79 1.3-6.82 1.2-6.49 3.1-14.03 1.3-18.89-.7-1.64-5.1 7.5-6 7.67-.6.11-.3-3.85-.3-4.45-.1-4.23 1.3-9.35-1.4-11.75-1.4-1.22-3 5.6-4.1 5.06-3-1.42-2.6-8.25-6.6-8.81-3.1-.43-3 3.23-5 3.62-3.5.64-4.4-3.06-9.1.51-1.3.98-3.7 3.11-4.4 4.62-.5.96.1 2.37-.8 2.82-2.2 1.11-4-.3-7.5 3.47-6.2 6.74-5.1 12.33-7.8 18.69-.5 1.06-3.9 2.65-5 4.14-5.7 8.25-12.6 19.78-11.9 27.52.3 3.44 4.7 1.55 4.9 3.96.1 1.73-3.6 6.29-2.7 7.25 5.4 5.28 10.6-6.51 13.9-6.59 1.6-.04-2.9 6.48-.8 5.9 2.6-.69 11.6-11.07 12.5-10.64 1.1.52-1.7 7.75.5 7.05 6.5-2.07 13.2-12.2 18.9-14.02 2.4-.77-1.4 6.49.5 6.64 3.6.26 9.7-6.47 13-5.51 1.9.53 4.6 1.05 5.7 2.39.7.8.6 4.96.7 3.61"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16156.3 1547.02c.4.24-.5-5.52-.4-6.67.1-5.35.4-10 1.6-15.85.6-2.51 1.9-6.12 3.2-8.71.7-1.37 2.3-5.43 1.4-4.11-.8 1.21-5.7 10.19-7.2 9.48-.7-.37 1.1-5.79 1.3-6.82 1.2-6.49 3.1-14.03 1.3-18.89-.7-1.64-5.1 7.5-6 7.67-.6.11-.3-3.85-.3-4.45-.1-4.23 1.3-9.35-1.4-11.75-1.4-1.22-3 5.6-4.1 5.06-3-1.42-2.6-8.25-6.6-8.81-3.1-.43-3 3.23-5 3.62-3.5.64-4.4-3.06-9.1.51-1.3.98-3.7 3.11-4.4 4.62-.5.96.1 2.37-.8 2.82-2.2 1.11-4-.3-7.5 3.47-6.2 6.74-5.1 12.33-7.8 18.69-.5 1.06-3.9 2.65-5 4.14-5.7 8.25-12.6 19.78-11.9 27.52.3 3.44 4.7 1.55 4.9 3.96.1 1.73-3.6 6.29-2.7 7.25 5.4 5.28 10.6-6.51 13.9-6.59 1.6-.04-2.9 6.48-.8 5.9 2.6-.69 11.6-11.07 12.5-10.64 1.1.52-1.7 7.75.5 7.05 6.5-2.07 13.2-12.2 18.9-14.02 2.4-.77-1.4 6.49.5 6.64 3.6.26 9.7-6.47 13-5.51 1.9.53 4.6 1.05 5.7 2.39.7.8.6 4.96.7 3.61"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16165.6 1555.59c-.1.17 3.7-5.2 4.8-6.83 3.4-5.01 5.2-10.27 8.5-15.21 2.9-4.3 2.8.31 3.4-.29 1.4-1.44 1.9-5.34 3.2-7.19 1.9-2.51 4-5.46 6.3-7.4 1-.88.8 1.51 1.7.47 3.7-4.33 5.1-9.49 9.7-13.41 1.7-1.45 2.4.58 3.2-.04 3.8-2.71 3.4-5.6 9.5-8.17 1.5-.6 2.4 2.66 3.9 2.78.9.07 2.2-2.46 2.8-2.48 3.4-.08 1.4 4.61 2.5 6.44.1.09 3.1-1.42 3.9-.76 1.5 1.42-2 5.72-1.3 7.41.3.93 2.6-.98 3.3-.34 1.7 1.39.8 8.78.8 11.64-.2 5.14-9.5 23.78-16 25.04-4.4.85-3.5-2.21-6.3-3.56-.4-.18.1 1.04 0 1.6-.1.92.2 4.18-1.3 4.97-3.4 1.78-4.8-2.67-7-1.07-.7.52-1.4 6.65-3.5 6.7-2.1.06-2.4-6.3-4.6-5.12-1.4.71-1.3 4.69-3.8 5.51-3.3 1.06-2.8-4.76-5.2-5.11-2.9-.43-2.7 4.8-4.9 5.51-1.6.53-3.1-4.9-4.6-3.77-1.3.9-1.7 2.74-2.9 3.8-.6.57-1.8-2.86-2.9-2.65-1 .19-7.5 5.75-7.2 6.48"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16165.6 1555.59c-.1.17 3.7-5.2 4.8-6.83 3.4-5.01 5.2-10.27 8.5-15.21 2.9-4.3 2.8.31 3.4-.29 1.4-1.44 1.9-5.34 3.2-7.19 1.9-2.51 4-5.46 6.3-7.4 1-.88.8 1.51 1.7.47 3.7-4.33 5.1-9.49 9.7-13.41 1.7-1.45 2.4.58 3.2-.04 3.8-2.71 3.4-5.6 9.5-8.17 1.5-.6 2.4 2.66 3.9 2.78.9.07 2.2-2.46 2.8-2.48 3.4-.08 1.4 4.61 2.5 6.44.1.09 3.1-1.42 3.9-.76 1.5 1.42-2 5.72-1.3 7.41.3.93 2.6-.98 3.3-.34 1.7 1.39.8 8.78.8 11.64-.2 5.14-9.5 23.78-16 25.04-4.4.85-3.5-2.21-6.3-3.56-.4-.18.1 1.04 0 1.6-.1.92.2 4.18-1.3 4.97-3.4 1.78-4.8-2.67-7-1.07-.7.52-1.4 6.65-3.5 6.7-2.1.06-2.4-6.3-4.6-5.12-1.4.71-1.3 4.69-3.8 5.51-3.3 1.06-2.8-4.76-5.2-5.11-2.9-.43-2.7 4.8-4.9 5.51-1.6.53-3.1-4.9-4.6-3.77-1.3.9-1.7 2.74-2.9 3.8-.6.57-1.8-2.86-2.9-2.65-1 .19-7.5 5.75-7.2 6.48"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16169.3 1544.03c.4.93-1.4 5.16-1.8 6.53-1.7 6.38-.4 13.05-5.7 19.76-1.3 1.6-2.6 2.36-3 .83-.1-.46-.4-3.71-.5-3.48-.6 1.18.7 18.62-6.3 18.8-1.5.04-1.7-4.25-2.9-2.42-2.5 3.86 3 9.91-2 15.09-4.1 4.36-2.8-4.91-4.4-3.22-.5.52.3 3.34.3 3.85.2 2.07-1.3 8.08-3.7 10.19-2.7 2.39-2.3-5.1-2.6-4.96-1.4.77-.7 10.23-3.7 10.83-1.9.38-.2-6.17-1.5-5.91-.4.09-1.8 4.73-2 5.15-1.8 4.65-4 8.01-7.4 7.49-1.2-.19 2.7-10.66 1.7-10.45-.7.13-2.3 4.57-2.6 5.22-1.6 3.31-5.4 13.21-8.8 15.07-5.3 2.84.2-8.43-.4-8.73-.4-.25-5.4 11.31-7.4 11.15-2.2-.17 1.8-8.3 1.4-9.63-.1-.21-6.2 6.61-4.3 1.53.8-2.23 1.5-5.33 2.7-7.54.8-1.34 3.7-4.98 2.9-3.68-.7 1.07-2.1 2.44-2.9 3.38-8.2 9.23-2.5-5.35.2-8.86.2-.21.8-.91 1-.95.6-.13-1.2 1.38-1.8 2.06-.7.77-4 4.55-4.5 3.47-.8-1.82.9-6.57 2.6-8.9.2-.29 3.3-3.8 3.3-3.89-.5-1.55-7.1 8.08-4.7.65.2-.71.5-1.45.7-2.18 2.1-5.07 5.8-8.33 9.7-11.57.6-.48 4-3.09 4-3.97 0-.12-2.1 1.65-2.4 1.82-1.5.82-3 1.73-2.7-.4.8-5.97 7-8.64 11.2-12.3.7-.63-1.1-.35-1.1-.95 0-1.35.9-3.41 2.2-4.67 2.3-2.4 6.6-4.01 8.3-6.07 2.1-2.48.9-5.21 4.7-7.04 3-1.44 5.6.21 8.1-1.15.7-.38 1.1-5.27 3.4-6.91 3.4-2.37 5.1 1.11 7.9.71.9-.14 1.5-3.07 2.6-3.81 2-1.46 4.2-.69 5.6-.35 1.9.46 4 .78 6.1.85.4.01 2.4 1.28 2.5.56"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16169.3 1544.03c.4.93-1.4 5.16-1.8 6.53-1.7 6.38-.4 13.05-5.7 19.76-1.3 1.6-2.6 2.36-3 .83-.1-.46-.4-3.71-.5-3.48-.6 1.18.7 18.62-6.3 18.8-1.5.04-1.7-4.25-2.9-2.42-2.5 3.86 3 9.91-2 15.09-4.1 4.36-2.8-4.91-4.4-3.22-.5.52.3 3.34.3 3.85.2 2.07-1.3 8.08-3.7 10.19-2.7 2.39-2.3-5.1-2.6-4.96-1.4.77-.7 10.23-3.7 10.83-1.9.38-.2-6.17-1.5-5.91-.4.09-1.8 4.73-2 5.15-1.8 4.65-4 8.01-7.4 7.49-1.2-.19 2.7-10.66 1.7-10.45-.7.13-2.3 4.57-2.6 5.22-1.6 3.31-5.4 13.21-8.8 15.07-5.3 2.84.2-8.43-.4-8.73-.4-.25-5.4 11.31-7.4 11.15-2.2-.17 1.8-8.3 1.4-9.63-.1-.21-6.2 6.61-4.3 1.53.8-2.23 1.5-5.33 2.7-7.54.8-1.34 3.7-4.98 2.9-3.68-.7 1.07-2.1 2.44-2.9 3.38-8.2 9.23-2.5-5.35.2-8.86.2-.21.8-.91 1-.95.6-.13-1.2 1.38-1.8 2.06-.7.77-4 4.55-4.5 3.47-.8-1.82.9-6.57 2.6-8.9.2-.29 3.3-3.8 3.3-3.89-.5-1.55-7.1 8.08-4.7.65.2-.71.5-1.45.7-2.18 2.1-5.07 5.8-8.33 9.7-11.57.6-.48 4-3.09 4-3.97 0-.12-2.1 1.65-2.4 1.82-1.5.82-3 1.73-2.7-.4.8-5.97 7-8.64 11.2-12.3.7-.63-1.1-.35-1.1-.95 0-1.35.9-3.41 2.2-4.67 2.3-2.4 6.6-4.01 8.3-6.07 2.1-2.48.9-5.21 4.7-7.04 3-1.44 5.6.21 8.1-1.15.7-.38 1.1-5.27 3.4-6.91 3.4-2.37 5.1 1.11 7.9.71.9-.14 1.5-3.07 2.6-3.81 2-1.46 4.2-.69 5.6-.35 1.9.46 4 .78 6.1.85.4.01 2.4 1.28 2.5.56"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16154.1 1555.44c-2.9 5.13-8.3 7.32-11.6 11.96-8.7 11.87-19.3 31.84-24.2 45.93"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16154.1 1555.44c-2.9 5.13-8.3 7.32-11.6 11.96-8.7 11.87-19.3 31.84-24.2 45.93"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16137 1590.25c.5 5.45 1.4 7.8-1.9 15.41Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16137 1590.25c.5 5.45 1.4 7.8-1.9 15.41"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16143.8 1580.15c3.4-.89-.1 7.04-.9 10.86Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16143.8 1580.15c3.4-.89-.1 7.04-.9 10.86"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16149.1 1569.96c2.6-1.85.5 6.84.1 8.74Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16149.1 1569.96c2.6-1.85.5 6.84.1 8.74"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16119.8 1591.7c.2-.24-2 1.97-2.5 2.47-2 1.89-3.9 3.8-6 5.48"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16119.8 1591.7c.2-.24-2 1.97-2.5 2.47-2 1.89-3.9 3.8-6 5.48"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16127.7 1575.84c-3.9.1-8.9 5.49-13 9.26Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16127.7 1575.84c-3.9.1-8.9 5.49-13 9.26"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16135.7 1563.31c.7-1.23-1.9.65-2.2.82-2.8 1.59-5.6 3.14-8.4 4.71"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16135.7 1563.31c.7-1.23-1.9.65-2.2.82-2.8 1.59-5.6 3.14-8.4 4.71"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16171.3 1548.52c12.9-11.02 24.4-21.8 38.1-29.03 1.6-.87 13-6.64 12.1-3.5"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16171.3 1548.52c12.9-11.02 24.4-21.8 38.1-29.03 1.6-.87 13-6.64 12.1-3.5"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16197 1520.81c1.7-1.75 4.7-5.14 6-7.36Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16197 1520.81c1.7-1.75 4.7-5.14 6-7.36"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16208.5 1515.7c1.6-2.78 3-5.03 5-7.58Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16208.5 1515.7c1.6-2.78 3-5.03 5-7.58"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16180.2 1528.74c2.2-1.82 3.8-3.88 5.2-6.56Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16180.2 1528.74c2.2-1.82 3.8-3.88 5.2-6.56"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16181 1542.18c4.1-.09 12.6-1.28 15 .83Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16181 1542.18c4.1-.09 12.6-1.28 15 .83"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16198.8 1534.84c2.1-2.1 5.2 2.5 8.7 5.53Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16198.8 1534.84c2.1-2.1 5.2 2.5 8.7 5.53"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16210.5 1528.91c2.7 3.28 8.7 2.98 11.6 6.27Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16210.5 1528.91c2.7 3.28 8.7 2.98 11.6 6.27"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16155.8 1544.31c1.7-5.18-3.4-11.26-5.7-13.27-8.9-7.83-22.1-16.36-35.8-17.2-5-.3-10.3-.25-16.1 1.62-1.9.62-5.2 2.27-6 .72"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16155.8 1544.31c1.7-5.18-3.4-11.26-5.7-13.27-8.9-7.83-22.1-16.36-35.8-17.2-5-.3-10.3-.25-16.1 1.62-1.9.62-5.2 2.27-6 .72"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16142 1522.85c2-4.38 3.4-8.27 2.5-11.76Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16142 1522.85c2-4.38 3.4-8.27 2.5-11.76"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16132.2 1513.71c1.6-5.22.6-5.44.3-12.49Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16132.2 1513.71c1.6-5.22.6-5.44.3-12.49"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16121.9 1514.13c-.9 1.08-1.5-10.2-2.9-13.4Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16121.9 1514.13c-.9 1.08-1.5-10.2-2.9-13.4"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16139.5 1532.28c-2.9-1.44-9.3 5.39-12.6 7.91Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16139.5 1532.28c-2.9-1.44-9.3 5.39-12.6 7.91"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16127.2 1526.32c-4.5 3.81-8.9 7.61-13.3 11.42Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16127.2 1526.32c-4.5 3.81-8.9 7.61-13.3 11.42"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="m16114.6 1523.61-11.4 12.96Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="m16114.6 1523.61-11.4 12.96"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16118.1 1499.26c-1.6-3.88-2.9-7.27-5.1-10.71Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16118.1 1499.26c-1.6-3.88-2.9-7.27-5.1-10.71"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16110.1 1512.13c-.6 1.02-3.8 1.83-4.7 2.57-2.6 1.96-4.2 5.09-5.8 7.92"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16110.1 1512.13c-.6 1.02-3.8 1.83-4.7 2.57-2.6 1.96-4.2 5.09-5.8 7.92"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16560.4 1550.07c.1.15-3.5-4.66-4.6-6.05-3.5-4.26-8.2-7.05-11.7-11.25-3-3.66 1.9-2.56 1.6-3.25-.8-1.66-4.7-2.96-5.9-4.65-1.7-2.29-3.7-4.89-4.5-7.47-.4-1.16 2.1-.52 1.5-1.58-2.6-4.42-7.4-6.84-9.1-12.04-.6-1.92 2-2.09 1.8-3.03-.8-4.15-4.2-4.38-3.5-10.76.1-1.51 4.1-1.66 5.1-3.05.6-.88-1.4-2.62-1.1-3.16 1.8-3.26 5.7-.35 8.3-1.07.1-.04.2-3.25 1.3-3.8 2.4-1.17 5.1 3.06 7.3 2.82 1.1-.12.4-2.67 1.5-3.26 2.4-1.27 9.8 1.11 12.9 1.8 5.4 1.22 20.2 14.03 18 20.49-1.5 4.31-4.3 2.84-7.3 5.17-.4.31 1.1.17 1.7.34.9.27 4.6.7 4.6 2.31 0 3.58-5.5 3.95-5 6.38.1.79 6.4 2.73 5.3 4.71-1.2 2.09-8.2.99-8.1 3.36 0 1.44 4.3 2.2 3.8 4.75-.7 3.3-6.7 1.61-8.4 3.79-2.1 2.72 3.7 3.61 3.2 5.83-.3 1.67-6.9 1.89-6.6 3.61.3 1.37 2 2.15 2.5 3.47.3.72-4.1 1.17-4.5 2.25-.3.99 2.1 8.29 3 8.19"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16560.4 1550.07c.1.15-3.5-4.66-4.6-6.05-3.5-4.26-8.2-7.05-11.7-11.25-3-3.66 1.9-2.56 1.6-3.25-.8-1.66-4.7-2.96-5.9-4.65-1.7-2.29-3.7-4.89-4.5-7.47-.4-1.16 2.1-.52 1.5-1.58-2.6-4.42-7.4-6.84-9.1-12.04-.6-1.92 2-2.09 1.8-3.03-.8-4.15-4.2-4.38-3.5-10.76.1-1.51 4.1-1.66 5.1-3.05.6-.88-1.4-2.62-1.1-3.16 1.8-3.26 5.7-.35 8.3-1.07.1-.04.2-3.25 1.3-3.8 2.4-1.17 5.1 3.06 7.3 2.82 1.1-.12.4-2.67 1.5-3.26 2.4-1.27 9.8 1.11 12.9 1.8 5.4 1.22 20.2 14.03 18 20.49-1.5 4.31-4.3 2.84-7.3 5.17-.4.31 1.1.17 1.7.34.9.27 4.6.7 4.6 2.31 0 3.58-5.5 3.95-5 6.38.1.79 6.4 2.73 5.3 4.71-1.2 2.09-8.2.99-8.1 3.36 0 1.44 4.3 2.2 3.8 4.75-.7 3.3-6.7 1.61-8.4 3.79-2.1 2.72 3.7 3.61 3.2 5.83-.3 1.67-6.9 1.89-6.6 3.61.3 1.37 2 2.15 2.5 3.47.3.72-4.1 1.17-4.5 2.25-.3.99 2.1 8.29 3 8.19"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16557 1542.49c-4.7-14.67-9.8-27.99-9.9-42.61-.1-1.77.1-13.94 3-12.36"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16557 1542.49c-4.7-14.67-9.8-27.99-9.9-42.61-.1-1.77.1-13.94 3-12.36"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16543.6 1509.24c-.7-2.31-2.5-6.4-4-8.35Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16543.6 1509.24c-.7-2.31-2.5-6.4-4-8.35"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16544.2 1496.73c-1.8-2.59-3.3-4.74-4.7-7.66Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16544.2 1496.73c-1.8-2.59-3.3-4.74-4.7-7.66"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16543.2 1527.81c-.6-2.82-1.8-5.08-3.7-7.3Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16543.2 1527.81c-.6-2.82-1.8-5.08-3.7-7.3"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16555.1 1532.72c1.9-3.32 4.9-10.39 8.2-11.97Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16555.1 1532.72c1.9-3.32 4.9-10.39 8.2-11.97"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16556.6 1514.14c-1.1-1.95 4.9-3.58 9.5-5.77Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16556.6 1514.14c-1.1-1.95 4.9-3.58 9.5-5.77"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16556.8 1501.06c4.2-1.53 6.6-6.1 11-7.77Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.934}
      d="M16556.8 1501.06c4.2-1.53 6.6-6.1 11-7.77"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16548.4 1555.85c.2.19.5.79.7.79Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16548.4 1555.85c.2.19.5.79.7.79"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16548.3 1555.37c2.5 0-2.9 18.68-1.1 23.03 1.2 3.15 5.4-.58 6.1-2.18.3-.51 1.6-5.26 1.7-5.17 5.1 7.59-11.7 24.52-1.2 32.06 2.2 1.59 4.4 2.03 6.3-.17 1.3-1.59 1.7-6.03 1.7-6.03s-.3 5.98-.4 8.97c-.1 5.11 4.7 12.36 9.6 14.2 5.5 2.06 4-7.96 4.5-8.47 0-.01 2.4 4.63 2.7 5.09 1.2 1.92 8.7 8.33 11 6.32 1.2-1.02 1.4-4.17 2-5.59.4-1.1.9-12.19-.6-12.19-.3 0 1.1 1.65 1.2 1.71 1.6 1.63 11.5 4.35 10.9-.42-.7-4.74-4.3-6.9-8.2-8.81-1.7-.88-6.7-3.46-4.8-3.46 3.6 0 8.8 5.89 11.7.09 1.1-2.32-.5-5.5-1.5-7.61-2.9-5.66-10.5-3.85-13.6-8.08-2.5-3.54 5.7-5.53 0-9.49-2.1-1.47-7.8 2.07-9.5-.64-.8-1.45 5.9-.37 5.3-3.38-1.2-5.75-7.5-6.37-10.6-9.02-1.7-1.49-2.1-4.99-3.5-5.98-4.4-3.34-17.7 3.89-21.3-3.29"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16548.3 1555.37c2.5 0-2.9 18.68-1.1 23.03 1.2 3.15 5.4-.58 6.1-2.18.3-.51 1.6-5.26 1.7-5.17 5.1 7.59-11.7 24.52-1.2 32.06 2.2 1.59 4.4 2.03 6.3-.17 1.3-1.59 1.7-6.03 1.7-6.03s-.3 5.98-.4 8.97c-.1 5.11 4.7 12.36 9.6 14.2 5.5 2.06 4-7.96 4.5-8.47 0-.01 2.4 4.63 2.7 5.09 1.2 1.92 8.7 8.33 11 6.32 1.2-1.02 1.4-4.17 2-5.59.4-1.1.9-12.19-.6-12.19-.3 0 1.1 1.65 1.2 1.71 1.6 1.63 11.5 4.35 10.9-.42-.7-4.74-4.3-6.9-8.2-8.81-1.7-.88-6.7-3.46-4.8-3.46 3.6 0 8.8 5.89 11.7.09 1.1-2.32-.5-5.5-1.5-7.61-2.9-5.66-10.5-3.85-13.6-8.08-2.5-3.54 5.7-5.53 0-9.49-2.1-1.47-7.8 2.07-9.5-.64-.8-1.45 5.9-.37 5.3-3.38-1.2-5.75-7.5-6.37-10.6-9.02-1.7-1.49-2.1-4.99-3.5-5.98-4.4-3.34-17.7 3.89-21.3-3.29"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16551.9 1556.3c19.3 12.86 13.9 32.69 26.2 44.93Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16551.9 1556.3c19.3 12.86 13.9 32.69 26.2 44.93"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16561.2 1574.43c4.6 6.22 1.4 14.53 2.3 21.67Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16561.2 1574.43c4.6 6.22 1.4 14.53 2.3 21.67"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16575.9 1583.53c3.4.69 8.1.74 11.3 2.61Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16575.9 1583.53c3.4.69 8.1.74 11.3 2.61"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16584.6 1599.39c2.2-.94 4.4 1.75 6.6 1.75Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16584.6 1599.39c2.2-.94 4.4 1.75 6.6 1.75"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16567.4 1565.62c-.1-.45-1.1-2.51-.7-2.95 1.3-1.28 5.4-.82 5.4.99"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16567.4 1565.62c-.1-.45-1.1-2.51-.7-2.95 1.3-1.28 5.4-.82 5.4.99"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16553.6 1547.93c0-.39.6-.77.8-1.03 4.4-3.8 10.1-4.29 14.5-9.19 5.5-6.16 12.9-21.03 21.7-22.91 4.6-.99 5.3 8.07 8.4 7.44 4-.79 3.7-9.32 9.7-9.91 5.1-.52 9 2.29 11 6.66 0 .16.3.99.6.99 2.6 0 4.9-7.34 9.8-6.8 5.5.62 5.4 8.59 8.5 9.62.8.29 2.5-3.34 4.6-2.99 7.1 1.18 3.5 8.14 6.8 10 4.9 2.79 11.6-2.37 13.2 7.73 1.9 11.44-8.5 7.72-9.2 10.52-.8 3.23 12.1 6.36 8.1 12.95-1.8 2.94-9-.28-9.3.51-.4 1.05 8.3 9.94 2.7 10.56-10.5 1.17-14.7-17.52-25-14.11-.3.12.9 1.65 1 1.84.8 1.31 4.9 9.28.9 9.28-6.8 0-12.5-12.83-19.7-11.03-2 .51 2.4 10.01-.1 10.64-4.7 1.18-10.5-12.45-13.6-10.9-1.7.84 3.2 9.83 1.9 11.93-1.2 2-13.5-9.95-14.5-10.56-2.7-1.76-5.1-3.78-7.7-5.64-2.1-1.47-1.3 2.14-1.9 1.96-1.1-.26-8.6-6.01-8.3-6.79"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16553.6 1547.93c0-.39.6-.77.8-1.03 4.4-3.8 10.1-4.29 14.5-9.19 5.5-6.16 12.9-21.03 21.7-22.91 4.6-.99 5.3 8.07 8.4 7.44 4-.79 3.7-9.32 9.7-9.91 5.1-.52 9 2.29 11 6.66 0 .16.3.99.6.99 2.6 0 4.9-7.34 9.8-6.8 5.5.62 5.4 8.59 8.5 9.62.8.29 2.5-3.34 4.6-2.99 7.1 1.18 3.5 8.14 6.8 10 4.9 2.79 11.6-2.37 13.2 7.73 1.9 11.44-8.5 7.72-9.2 10.52-.8 3.23 12.1 6.36 8.1 12.95-1.8 2.94-9-.28-9.3.51-.4 1.05 8.3 9.94 2.7 10.56-10.5 1.17-14.7-17.52-25-14.11-.3.12.9 1.65 1 1.84.8 1.31 4.9 9.28.9 9.28-6.8 0-12.5-12.83-19.7-11.03-2 .51 2.4 10.01-.1 10.64-4.7 1.18-10.5-12.45-13.6-10.9-1.7.84 3.2 9.83 1.9 11.93-1.2 2-13.5-9.95-14.5-10.56-2.7-1.76-5.1-3.78-7.7-5.64-2.1-1.47-1.3 2.14-1.9 1.96-1.1-.26-8.6-6.01-8.3-6.79"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16578.3 1542.03c0-3.33 9.9-1.55 12.4-1.41 10.7.56 21.4-.43 32 1.28 2.4.39 8.5.63 10.1 2.61"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16578.3 1542.03c0-3.33 9.9-1.55 12.4-1.41 10.7.56 21.4-.43 32 1.28 2.4.39 8.5.63 10.1 2.61"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16586.4 1549.81c3.2 0 8.5 4.7 11.3 6.28Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16586.4 1549.81c3.2 0 8.5 4.7 11.3 6.28"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16602.5 1549.89c3.5.88 7 2.61 10.3 4.24Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16602.5 1549.89c3.5.88 7 2.61 10.3 4.24"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16613.6 1549.43c3.8 1.63 8.1 2.51 11.4 5Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16613.6 1549.43c3.8 1.63 8.1 2.51 11.4 5"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16607.7 1534.98c3.8-3.87 16.5-4.82 21.5-5.82Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16607.7 1534.98c3.8-3.87 16.5-4.82 21.5-5.82"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16594.2 1532.37c3.7-3.71 10.9-4.79 15-6.16Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16594.2 1532.37c3.7-3.71 10.9-4.79 15-6.16"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16580.1 1533.82c4.1-3.12 6.9-5.08 10.2-8.29Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16580.1 1533.82c4.1-3.12 6.9-5.08 10.2-8.29"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16476.7 1435.54c-.4.23 1.9-2.36 2.5-3.01 2.1-2.2 4.4-4.45 7-6.04 6.8-4.09 17.1-7.02 24.8-9.04 4.3-1.13 9.2-3.03 13.6-3.37.9-.07 4.3-.27 4.6-1.37.3-1.44-11-3.06-8.9-4.54 3.8-2.73 10.5-1.78 15-2.57 6.2-1.09 12.8-5.94 16.9-10.64.4-.47-8.3-2.48-7.9-3.45.8-1.97 6-2.96 7.9-3.45 5.5-1.43 12.8-3.63 16.2-8.35 4-5.43-6.3-1.58-5.3-4.96.6-2.29 4-2.94 5.8-4.14 3.4-2.38 8.5-7.14 10.1-11.07 1.2-3.03-4.2-.5-4.1-1.25 1.4-6.63 11.2-16.93 5.3-24.49-1.2-1.58-6.8 4.72-7.1 1.9-.8-7.31 4.3-17.09-1.5-23.65-2.8-3.24-4.8 3.74-5.9 1.49-1.1-2.24-.5-8.54-.9-11.36-.8-5.82-6.6-13.92-9.9-18.57-1.1-1.65-2.6-6.57-4.6-7.26-1.8-.61-15.1 6.46-17.9 7.9-.6.32-4.1 3.22-4.3 3.16-1-.61.3-8.05-2.4-8.23-3.6-.23-9.2 11.55-12.4 12.79-1.6.64-.7-2.39-1.7-3.17-1.3-1.01-6.4-.8-8-.22-5.5 2.04-4.6 12.56-8.9 15.39-.1.02-1.4-4.32-1.8-4.81-1.4-1.82-3.8-.02-4.8 1.14-3.3 3.94-5 13.37-4.8 18.07 0 1.82 1.8 6.2.9 7.77-.2.26-.4.14-.5-.01-2.1-2.44-5.2-6.31-7.7-1.46-1.5 2.9-.6 13.89 1.2 16.58.7 1.13 4.3 6.43 3.7 7.47-.3.55-4.5-1.9-5.1-1.95-1.7-.15-4.1 3.91-4.3 5.43-.6 5.18 6 18.7 8.5 23.52 1.5 2.85 5 6.41 5.2 9.77.3 4.76-8-2.6-8.5 1.58-.4 4.71 4.3 9.4 6 13.48 2.2 5.12 2.9 10.95 1.9 16.37-.9 5.71-3.4 9.9-6.2 14.82-1 1.61-1.9 3.25-3.1 4.68-.2.35-2.1 2.06-1.6 2.1"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16476.7 1435.54c-.4.23 1.9-2.36 2.5-3.01 2.1-2.2 4.4-4.45 7-6.04 6.8-4.09 17.1-7.02 24.8-9.04 4.3-1.13 9.2-3.03 13.6-3.37.9-.07 4.3-.27 4.6-1.37.3-1.44-11-3.06-8.9-4.54 3.8-2.73 10.5-1.78 15-2.57 6.2-1.09 12.8-5.94 16.9-10.64.4-.47-8.3-2.48-7.9-3.45.8-1.97 6-2.96 7.9-3.45 5.5-1.43 12.8-3.63 16.2-8.35 4-5.43-6.3-1.58-5.3-4.96.6-2.29 4-2.94 5.8-4.14 3.4-2.38 8.5-7.14 10.1-11.07 1.2-3.03-4.2-.5-4.1-1.25 1.4-6.63 11.2-16.93 5.3-24.49-1.2-1.58-6.8 4.72-7.1 1.9-.8-7.31 4.3-17.09-1.5-23.65-2.8-3.24-4.8 3.74-5.9 1.49-1.1-2.24-.5-8.54-.9-11.36-.8-5.82-6.6-13.92-9.9-18.57-1.1-1.65-2.6-6.57-4.6-7.26-1.8-.61-15.1 6.46-17.9 7.9-.6.32-4.1 3.22-4.3 3.16-1-.61.3-8.05-2.4-8.23-3.6-.23-9.2 11.55-12.4 12.79-1.6.64-.7-2.39-1.7-3.17-1.3-1.01-6.4-.8-8-.22-5.5 2.04-4.6 12.56-8.9 15.39-.1.02-1.4-4.32-1.8-4.81-1.4-1.82-3.8-.02-4.8 1.14-3.3 3.94-5 13.37-4.8 18.07 0 1.82 1.8 6.2.9 7.77-.2.26-.4.14-.5-.01-2.1-2.44-5.2-6.31-7.7-1.46-1.5 2.9-.6 13.89 1.2 16.58.7 1.13 4.3 6.43 3.7 7.47-.3.55-4.5-1.9-5.1-1.95-1.7-.15-4.1 3.91-4.3 5.43-.6 5.18 6 18.7 8.5 23.52 1.5 2.85 5 6.41 5.2 9.77.3 4.76-8-2.6-8.5 1.58-.4 4.71 4.3 9.4 6 13.48 2.2 5.12 2.9 10.95 1.9 16.37-.9 5.71-3.4 9.9-6.2 14.82-1 1.61-1.9 3.25-3.1 4.68-.2.35-2.1 2.06-1.6 2.1"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16482.5 1432.12c6.6.75 12.7-2.32 18.9-3.75 13.1-3.02 24.3-6.72 36.5-12.4 5-2.34 9.6-6.53 15.2-7.47 1.1-.18 6-1.09 6.6.16.6 1.47-2.6 4.75-1 4.73 1.3-.02 3.3-2.29 4.3-2.89 2.5-1.37 14-6.09 16.8-3.28 1 1.08-.6 9.88.6 10.38 1.6.64 6.7-1.13 8.4-1.34 3.4-.44 10.1 2.09 12.5 4.67 1.6 1.72-4.7 7.59-4.6 7.63 3.2 1.58 10.9-1.31 16 1.27 2.6 1.32 6.9 5.27 4.5 8.25-.7.79-5.9 3.76-4.9 5.03 2.5 3.17 10.1.48 13.4 3.49 2.3 2.16 4.7 6.58 2.8 9.47-.7 1.09-5.3 4.82-4.4 6.38.6 1.16 5.3 1.21 6.6 1.56 2.7.76 4.9 2.86 6.6 5.07 2.2 2.88 2.6 5.65 1.9 9.19-.2.75-1.8 5.57-1.6 5.92.9 2 5.6-.2 6.5 2.48.5 1.48-1 5.7-1.7 6.86-.6.92-2.2 3.73-2 2.66"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16482.5 1432.12c6.6.75 12.7-2.32 18.9-3.75 13.1-3.02 24.3-6.72 36.5-12.4 5-2.34 9.6-6.53 15.2-7.47 1.1-.18 6-1.09 6.6.16.6 1.47-2.6 4.75-1 4.73 1.3-.02 3.3-2.29 4.3-2.89 2.5-1.37 14-6.09 16.8-3.28 1 1.08-.6 9.88.6 10.38 1.6.64 6.7-1.13 8.4-1.34 3.4-.44 10.1 2.09 12.5 4.67 1.6 1.72-4.7 7.59-4.6 7.63 3.2 1.58 10.9-1.31 16 1.27 2.6 1.32 6.9 5.27 4.5 8.25-.7.79-5.9 3.76-4.9 5.03 2.5 3.17 10.1.48 13.4 3.49 2.3 2.16 4.7 6.58 2.8 9.47-.7 1.09-5.3 4.82-4.4 6.38.6 1.16 5.3 1.21 6.6 1.56 2.7.76 4.9 2.86 6.6 5.07 2.2 2.88 2.6 5.65 1.9 9.19-.2.75-1.8 5.57-1.6 5.92.9 2 5.6-.2 6.5 2.48.5 1.48-1 5.7-1.7 6.86-.6.92-2.2 3.73-2 2.66"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15967.5 1415.17c-9.2 0-4.7 21.44-10.9 24.31-4.9 2.27-9.2-7.41-11.7-6.52-1.3.49-2.5 9.4-2.9 10.81-2 7.47-6.3 14.14-12 18.83-2.4 2.08-6-1.55-6.5-3.99-.1-.64.8-7.27-.3-6.87-1.4.5-2 9.67-4.2 11.61-4.9 4.42-6.5-4.53-6.8-4.44-2.4.89-2.1 7.23-5.1 7.62-3.5.49-4.6-6.2-7.4-7.22-.1-.02-1.9 5.64-3.7 5.93-2.5.39-4.9-7.04-6.7-8.17-2.3-1.42-7.2 1.33-8.5-3.44-1.3-4.95 8.4-10.5 8.8-14.24.7-5.86-9.8-4.12-4.6-11.31 4.9-6.89 17.7 1.98 21.4-4.04 1.5-2.37-9.8-10.42-2.6-13.35 5.6-2.29 10.9 4.47 15.5 3.64 2-.36 1.2-6.4 6.3-5.98 2.1.18 5.7 4.22 7.6 3.54 2.6-.92-.1-6.18 1.4-8.52 2.3-3.53 6.3 1.69 8.5.5 1.7-.89-1.5-6.67 2.6-5.88 6.7 1.27 11.5 6.67 16.5 11.11 1.2 1.08 4.4 4.88 6.1 4.88"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15967.5 1415.17c-9.2 0-4.7 21.44-10.9 24.31-4.9 2.27-9.2-7.41-11.7-6.52-1.3.49-2.5 9.4-2.9 10.81-2 7.47-6.3 14.14-12 18.83-2.4 2.08-6-1.55-6.5-3.99-.1-.64.8-7.27-.3-6.87-1.4.5-2 9.67-4.2 11.61-4.9 4.42-6.5-4.53-6.8-4.44-2.4.89-2.1 7.23-5.1 7.62-3.5.49-4.6-6.2-7.4-7.22-.1-.02-1.9 5.64-3.7 5.93-2.5.39-4.9-7.04-6.7-8.17-2.3-1.42-7.2 1.33-8.5-3.44-1.3-4.95 8.4-10.5 8.8-14.24.7-5.86-9.8-4.12-4.6-11.31 4.9-6.89 17.7 1.98 21.4-4.04 1.5-2.37-9.8-10.42-2.6-13.35 5.6-2.29 10.9 4.47 15.5 3.64 2-.36 1.2-6.4 6.3-5.98 2.1.18 5.7 4.22 7.6 3.54 2.6-.92-.1-6.18 1.4-8.52 2.3-3.53 6.3 1.69 8.5.5 1.7-.89-1.5-6.67 2.6-5.88 6.7 1.27 11.5 6.67 16.5 11.11 1.2 1.08 4.4 4.88 6.1 4.88"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15964.4 1409.69c.3.14 1.7-5.21 1.9-6.07.9-3.71 2.8-6.89 3.8-10.51 4.3-14.56 5.1-40.99 15.7-52.41 2.5-2.74 6.1-4.08 8.8-.95 2.1 2.49 2.4 9.82 2.4 9.82s1-4.54 1.6-6.78c1.3-4.5 5.6-14.5 11.5-13.45 5.8 1.05 2.4 6.48 4.6 8.87.2.17 2.4-3.2 2.6-3.49 1.3-2.33 3.2-4.27 6-3.78 6.6 1.19 2.2 8.86 4.5 11.41.6.58 4.1-2.3 5.5-1.4 5 3.23 3.4 5.99 5.5 10.41.3.59 3.2-2.26 4.5-.7 8.2 10.36-12.6 11.46-13.2 15.15-.6 3.81 6.8 5.88 5 11.75-1.3 4.39-7.5.7-8.8 4.29-1 2.59 2.8 4.84 1.3 7.92-1.2 2.63-6.5-2.13-8.7.7-2.3 3.03 2.7 6.87.3 10.16-2.9 3.88-6.9-1.59-9.7.3-2.6 1.75-1.3 6.97-3.4 9.31-.7.79-6.5-1.9-8.4-1.34-3.1.92-1.6 6.35-3.8 8.12-1.8 1.5-10.2-4.91-12-5.38-1.8-.49-3.1 1.97-4.7 2.34-2.3.53-5-.88-7 .85-1 .81-4.6-3.02-5.8-5.14"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15964.5 1411.18c0-11.12-1.7-16.7.6-27.82 1.3-5.98 4.8-11.27 6.4-17.13.8-2.77 2.3-13.88-2-15.05-2.7-.72-5.3 11.47-7.2 12.51-1.6.85-2.8-9.75-3.1-10.96-1.3-7.31-3.3-14.92-8.9-19.63-3.2-2.72-3.1 9.22-3.9 9.22-1.2 0-2.7-5.17-3.1-6.13-1.7-5.07-3.7-9.84-8-12.8-5.6-3.79-2.3 8.55-5.7 9.16-5.1.93-6.4-11.2-12.5-10.26-4.8.74-.7 9.04-2 9.76-1.2.64-8.2-6.81-10.8-7.22-7.2-1.1-1.7 9.08-1.8 9.12-3 1.07-7.1-7.07-10.6-4.93-5.6 3.31 1.4 4.98.4 9.51-.7 3.09-7.5-3.37-6.9 4.43.2 2.6 1.1 4.89 2.8 6.73.3.25 3.5 2.36 3.4 2.69-.8 1.61-6.7-1.64-7.9 2.54-2 6.44 3.4 5.87 5.8 9.76 1.7 2.8-1.1 4.9-.1 7.62 1.1 2.95 6.2 2.98 8.5 4.94 1.8 1.63.8 6.18 3.2 8.42 3.1 2.85 9.4-1.61 13.1 1.19 4 3.02 2.1 9.09 5.2 12.45 1.4 1.55 5.7-1.19 7.6-.89 4.1.62 6.6 5.25 10 5.78 3 .47 6-4.62 9-5.53 5.7-1.79 14.7 8.37 18.5 12.52"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15959.1 1396.39c.5-.56-6.7-9.53-7.1-10.12-7.6-11.3-17.7-23.92-28.8-31.22-4.4-2.87-8-6.98-12.5-9.66-.2-.15-4.6-2.25-4.6-2.06"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15959.1 1396.39c.5-.56-6.7-9.53-7.1-10.12-7.6-11.3-17.7-23.92-28.8-31.22-4.4-2.87-8-6.98-12.5-9.66-.2-.15-4.6-2.25-4.6-2.06"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15923.2 1365.76c-4.9-.8-9.7-2.38-14.5-1.42Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15923.2 1365.76c-4.9-.8-9.7-2.38-14.5-1.42"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15931.2 1375.47c-3.6 1.15-7.1 2.3-10.6 3.45Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15931.2 1375.47c-3.6 1.15-7.1 2.3-10.6 3.45"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15942.6 1385.64c-2.7 1.27-6.6 2.42-8.7 4.7Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15942.6 1385.64c-2.7 1.27-6.6 2.42-8.7 4.7"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15953.2 1377.4c-.6-3.82 2.5-8.05 4.6-10.71Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15953.2 1377.4c-.6-3.82 2.5-8.05 4.6-10.71"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15940.3 1361.94c2.2-3.76 1.6-7.92 1.9-12.6Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15940.3 1361.94c2.2-3.76 1.6-7.92 1.9-12.6"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15929 1347.91c.7-1.97-.2-7.25-.2-8.66Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15929 1347.91c.7-1.97-.2-7.25-.2-8.66"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15954.7 1415.26c0-1.49-5.1.06-5.2.08-5 1.06-6.9.78-11.2 4.24-9.8 8.11-15.2 16.29-28.1 19.79-2.5.69-10.1 5.62-10.1 5.34"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15954.7 1415.26c0-1.49-5.1.06-5.2.08-5 1.06-6.9.78-11.2 4.24-9.8 8.11-15.2 16.29-28.1 19.79-2.5.69-10.1 5.62-10.1 5.34"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15921.6 1426.56c-1.5-.4-6.9-3.5-7.9-2.48Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15921.6 1426.56c-1.5-.4-6.9-3.5-7.9-2.48"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15930 1441.18c.2-.12.1 2.04.1 2.27-.1 1.62-.1 3.24-.4 4.83"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15930 1441.18c.2-.12.1 2.04.1 2.27-.1 1.62-.1 3.24-.4 4.83"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15948.8 1422.86c1.9 0 2 6.18 1.8 7.48Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15948.8 1422.86c1.9 0 2 6.18 1.8 7.48"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15970.6 1407.74c.5 1.81 6.5-6.21 7-7.02 3-4.99 7.9-8.69 11.7-13.11 5.9-6.93 13.6-13.7 20.6-19.37 5.1-4.13 9.8-4.46 13.3-10.79"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15970.6 1407.74c.5 1.81 6.5-6.21 7-7.02 3-4.99 7.9-8.69 11.7-13.11 5.9-6.93 13.6-13.7 20.6-19.37 5.1-4.13 9.8-4.46 13.3-10.79"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16007.9 1360.17c.5-4.25-.2-8.49-.3-12.77Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M16007.9 1360.17c.5-4.25-.2-8.49-.3-12.77"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15996.3 1369.84c-.5-3.92-1-7.72-1.6-11.6Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15996.3 1369.84c-.5-3.92-1-7.72-1.6-11.6"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15986 1376.44c0-3.06-.8-6.32-1.1-9.37Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15986 1376.44c0-3.06-.8-6.32-1.1-9.37"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15990.7 1399.88c4.1 0 8.9.8 12.8.8Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M15990.7 1399.88c4.1 0 8.9.8 12.8.8"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16003.4 1385.13c4.2-1.12 4-.31 9.6 1.31Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M16003.4 1385.13c4.2-1.12 4-.31 9.6 1.31"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16014.8 1375.43c3.7-1.88 3.7-1.93 7.8-1.22Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.927}
      d="M16014.8 1375.43c3.7-1.88 3.7-1.93 7.8-1.22"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16468.2 1413.29c.5.13-2.9-3.78-3.4-4.4-2.2-2.69-3.7-6.2-6.3-8.53-7.5-6.86-12.6-16.68-17.9-25.24-16.9-26.89-32.8-54.87-53.4-79.18"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16468.2 1413.29c.5.13-2.9-3.78-3.4-4.4-2.2-2.69-3.7-6.2-6.3-8.53-7.5-6.86-12.6-16.68-17.9-25.24-16.9-26.89-32.8-54.87-53.4-79.18"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16450.4 1373.82c-1.2-4.24 2.1-7.65 2.5-11.89Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16450.4 1373.82c-1.2-4.24 2.1-7.65 2.5-11.89"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16438.7 1358.33c-1.3-8.97 4.9-17.11 6.4-25.71Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16438.7 1358.33c-1.3-8.97 4.9-17.11 6.4-25.71"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16425.2 1335.21c.9-7.97 4.7-15.41 9.3-21.89Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16425.2 1335.21c.9-7.97 4.7-15.41 9.3-21.89"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16414.7 1315.03c-.8-.92 0-3.63.3-4.61 1.1-4.1 2.8-8.78 5.1-12.36"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16414.7 1315.03c-.8-.92 0-3.63.3-4.61 1.1-4.1 2.8-8.78 5.1-12.36"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16404.3 1303.48c-2.6-5.05-.6-14.7 1.1-20.04Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16404.3 1303.48c-2.6-5.05-.6-14.7 1.1-20.04"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16443.5 1394.38c-.4.09-1.5-1.15-2-1.29-2.3-.59-7.5.08-9.1 1.65"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16443.5 1394.38c-.4.09-1.5-1.15-2-1.29-2.3-.59-7.5.08-9.1 1.65"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16431.8 1373.64c-7.9-2.86-17.1-.8-25 1.6Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16431.8 1373.64c-7.9-2.86-17.1-.8-25 1.6"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16415.3 1352.13c.1.42-2.6-.79-2.7-.84-1.6-.64-3.3-.95-5-1.33-5.2-1.18-10.5-.88-15.5 1.08"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16415.3 1352.13c.1.42-2.6-.79-2.7-.84-1.6-.64-3.3-.95-5-1.33-5.2-1.18-10.5-.88-15.5 1.08"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16399.3 1330.21c-.2.64-4.2-1.37-4.8-1.52-3.3-.95-7-1.17-10.3-.37-.1.03-3.9.82-3.9 1.75"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16399.3 1330.21c-.2.64-4.2-1.37-4.8-1.52-3.3-.95-7-1.17-10.3-.37-.1.03-3.9.82-3.9 1.75"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16390.2 1313.2c-5.6-1.92-11.2-4.54-17.2-2.97Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16390.2 1313.2c-5.6-1.92-11.2-4.54-17.2-2.97"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16490 1419.33c-3.5 4.26 7.7-8.8 8.9-10.01 7.3-7.44 13.1-16.14 18.8-24.82 14.3-21.93 24.8-44.54 29.7-70.38 1.3-6.75 4.5-14.45 4-21.35"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16490 1419.33c-3.5 4.26 7.7-8.8 8.9-10.01 7.3-7.44 13.1-16.14 18.8-24.82 14.3-21.93 24.8-44.54 29.7-70.38 1.3-6.75 4.5-14.45 4-21.35"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16528.6 1338.46c-.4-10.86-1.6-22.31-1.8-33.17Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16528.6 1338.46c-.4-10.86-1.6-22.31-1.8-33.17"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16522.9 1356.82c-3.5-14.54-7-29.07-10.3-43.63Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16522.9 1356.82c-3.5-14.54-7-29.07-10.3-43.63"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16513.3 1369.38c-1-1.92-6.3-11.82-7.1-13.65-4.2-9.72-1.5-24.08-1.7-34.3"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16513.3 1369.38c-1-1.92-6.3-11.82-7.1-13.65-4.2-9.72-1.5-24.08-1.7-34.3"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16503.8 1382.86c-2.1-7.8-7-26.28-9.3-35.29-.8-3.21-2.4-6.85-1.2-10.24"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16503.8 1382.86c-2.1-7.8-7-26.28-9.3-35.29-.8-3.21-2.4-6.85-1.2-10.24"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16499.4 1397.46c-.6-2.08-3.9-4.28-5-6.32-1.8-3.49-2.2-7.83-3-11.65"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16499.4 1397.46c-.6-2.08-3.9-4.28-5-6.32-1.8-3.49-2.2-7.83-3-11.65"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16548.2 1335.91c4.4-2.82 8.9-8.13 11.9-12.43Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16548.2 1335.91c4.4-2.82 8.9-8.13 11.9-12.43"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16545.2 1346.85c6.7-.08 11.8-5.2 16-9.58Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16545.2 1346.85c6.7-.08 11.8-5.2 16-9.58"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16536.9 1367.88c6.1-1.35 12.2-7.06 16.9-10.91.7-.58 7.6-7.08 7.5-7.12"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16536.9 1367.88c6.1-1.35 12.2-7.06 16.9-10.91.7-.58 7.6-7.08 7.5-7.12"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16527.7 1386.68c.8.47 3-.29 3.6-.69 9.2-5.54 17.2-9.24 24.1-16.54"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16527.7 1386.68c.8.47 3-.29 3.6-.69 9.2-5.54 17.2-9.24 24.1-16.54"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16514.8 1403.51c-.2.49 4.5-1.21 4.8-1.3 2.8-1.01 7.7-1.87 9.6-4.39"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16514.8 1403.51c-.2.49 4.5-1.21 4.8-1.3 2.8-1.01 7.7-1.87 9.6-4.39"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16482 1420.69c.2.21 1 1.62.2 1.57-1-.06-1.7-3.57-2-4.28-1.9-4.82-3.8-10.91-3.8-16.08-.1-9.61 1.8-19 2.1-28.55.1-1.66 1.9-8.22-.2-8.76-2.3-.58-5.6 4.45-7.5 3.65-3.4-1.37-1.1-6.59-.2-9.07 2.7-6.99 4-19.87 1-26.99-2.1-5-9.7 6.29-10.3 1.21-.9-8.25 8.6-21.1 1.6-30.05-4.2-5.48-7.3 4.15-9.5 2.84-1-.6-.2-5.65-.3-6.8-.1-4.42-1.3-11.31-5-14.25-2.1-1.65-6 4.25-6.5 3.72-1.9-2.21.4-10.91-5.5-11.04-2.4-.05-5.2 6.89-7.1 6.06-.9-.41-2.4-6.18-2.9-7.35-1.5-3.38-7.7-9.82-11.4-10.59-4.1-.87-6.4 2.54-8.9 5.36-.6.62-1.7 3.4-2.6 3.34-.1 0-3.6-6.58-4.2-7.32-3.2-4.09-13.4-9.38-18.9-6.92-6.9 3.11 1 8.72-1.2 11.57-1.7 2.11-10.5.51-10.3 5.56.2 3.98 8.1 9.19 7.1 12.16-1.6 4.39-13.8-5.49-12.4 2.53.9 5.45 5.1 14.17 8.3 18.71 1.1 1.46 6.2 3.9 6.3 5.33 0 1.05-3.2 1.53-3.8 1.62-2.8.41-10.7-1.04-10.2 4.13.3 2.43 3.6 4.05 5.2 5.51 3 2.72 5.3 6.34 8.2 8.91 1.5 1.29 6.1 3.46 6.9 5.34 1.2 2.86-10-.45-10.1 3.4-.1 3 5.7 4.83 7.5 6.2 2.1 1.61 3.2 4.67 5.2 6.02 4.2 2.77 11.2 5.69 14.5 9.42.4.55-3.8 1.44-4.2 1.49-1.5.25-10 2.37-7.8 5.61 2.2 3.17 5.1 3.63 8.2 5.47 7.7 4.48 14.9 10.83 23.3 14.23 2.8 1.17 5.7 2.33 8.8 2.6.8.06 5.1-.54 5.3.34.3 1.01-10.1 4.68-10.6 4.9-.3.15-3.2 1.48-2.8 2.02 2.1 3.3 12.7 2.65 16.1 3.18 13.9 2.12 43.2 6.11 44.3 24.55"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16482 1420.69c.2.21 1 1.62.2 1.57-1-.06-1.7-3.57-2-4.28-1.9-4.82-3.8-10.91-3.8-16.08-.1-9.61 1.8-19 2.1-28.55.1-1.66 1.9-8.22-.2-8.76-2.3-.58-5.6 4.45-7.5 3.65-3.4-1.37-1.1-6.59-.2-9.07 2.7-6.99 4-19.87 1-26.99-2.1-5-9.7 6.29-10.3 1.21-.9-8.25 8.6-21.1 1.6-30.05-4.2-5.48-7.3 4.15-9.5 2.84-1-.6-.2-5.65-.3-6.8-.1-4.42-1.3-11.31-5-14.25-2.1-1.65-6 4.25-6.5 3.72-1.9-2.21.4-10.91-5.5-11.04-2.4-.05-5.2 6.89-7.1 6.06-.9-.41-2.4-6.18-2.9-7.35-1.5-3.38-7.7-9.82-11.4-10.59-4.1-.87-6.4 2.54-8.9 5.36-.6.62-1.7 3.4-2.6 3.34-.1 0-3.6-6.58-4.2-7.32-3.2-4.09-13.4-9.38-18.9-6.92-6.9 3.11 1 8.72-1.2 11.57-1.7 2.11-10.5.51-10.3 5.56.2 3.98 8.1 9.19 7.1 12.16-1.6 4.39-13.8-5.49-12.4 2.53.9 5.45 5.1 14.17 8.3 18.71 1.1 1.46 6.2 3.9 6.3 5.33 0 1.05-3.2 1.53-3.8 1.62-2.8.41-10.7-1.04-10.2 4.13.3 2.43 3.6 4.05 5.2 5.51 3 2.72 5.3 6.34 8.2 8.91 1.5 1.29 6.1 3.46 6.9 5.34 1.2 2.86-10-.45-10.1 3.4-.1 3 5.7 4.83 7.5 6.2 2.1 1.61 3.2 4.67 5.2 6.02 4.2 2.77 11.2 5.69 14.5 9.42.4.55-3.8 1.44-4.2 1.49-1.5.25-10 2.37-7.8 5.61 2.2 3.17 5.1 3.63 8.2 5.47 7.7 4.48 14.9 10.83 23.3 14.23 2.8 1.17 5.7 2.33 8.8 2.6.8.06 5.1-.54 5.3.34.3 1.01-10.1 4.68-10.6 4.9-.3.15-3.2 1.48-2.8 2.02 2.1 3.3 12.7 2.65 16.1 3.18 13.9 2.12 43.2 6.11 44.3 24.55"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16475.3 1415.31c-9.9-16.99-19.2-35.16-29.9-51.71-6.4-9.8-13-19.5-18.9-29.63-11.9-20.76-22.6-42.3-36.7-61.76"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16475.3 1415.31c-9.9-16.99-19.2-35.16-29.9-51.71-6.4-9.8-13-19.5-18.9-29.63-11.9-20.76-22.6-42.3-36.7-61.76"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16407.1 1317.68c.8 0-1.6.25-2.3.28-1.5.05-2.9-.21-4.3-.28-4.9-.26-8.6-1.74-13.1-3.57"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16407.1 1317.68c.8 0-1.6.25-2.3.28-1.5.05-2.9-.21-4.3-.28-4.9-.26-8.6-1.74-13.1-3.57"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16419.5 1343.12c.1.38-1.5.23-1.8.24-1.6.06-3.1.28-4.6.51-7.8 1.2-14.1-.97-21.6-2.44"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16419.5 1343.12c.1.38-1.5.23-1.8.24-1.6.06-3.1.28-4.6.51-7.8 1.2-14.1-.97-21.6-2.44"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16432.8 1362.18c-.3 1.36-3.8 2.23-4.9 2.58-5.6 1.75-10.6 1.54-16.2.55"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16432.8 1362.18c-.3 1.36-3.8 2.23-4.9 2.58-5.6 1.75-10.6 1.54-16.2.55"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16450.4 1384.19c-5.9 2.26-12.3 5.55-18.9 4.67Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16450.4 1384.19c-5.9 2.26-12.3 5.55-18.9 4.67"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16463.6 1382.12c.4-1.75 2.1-6.72 2.5-9.81Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16463.6 1382.12c.4-1.75 2.1-6.72 2.5-9.81"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16452.9 1363.84c2.1-.75 2.9-4.8 3.4-6.56 2.3-7.12 3.4-13.13 2.1-20.56"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16452.9 1363.84c2.1-.75 2.9-4.8 3.4-6.56 2.3-7.12 3.4-13.13 2.1-20.56"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16440.6 1339.05c6.5-6.48 9.8-18.15 8.9-26.97Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16440.6 1339.05c6.5-6.48 9.8-18.15 8.9-26.97"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16426.5 1313.99c5.5-3.35 7.7-13.76 7.1-19.38Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16426.5 1313.99c5.5-3.35 7.7-13.76 7.1-19.38"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16415.7 1295.53c2.5-3.95 3-10.27 2.5-14.77Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16415.7 1295.53c2.5-3.95 3-10.27 2.5-14.77"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16395.8 1297.77c.8.39-.8.7-1 .68-1.4-.11-2.8-.62-4.1-1.16-3.2-1.28-7.2-3.27-9.9-5.52"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16395.8 1297.77c.8.39-.8.7-1 .68-1.4-.11-2.8-.62-4.1-1.16-3.2-1.28-7.2-3.27-9.9-5.52"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16056.6 1531.41c-2.4 1.8-5.6 5.29-8.5 6.67-3.3 1.61-4.8 5.87-8 7.3-3.3 1.44-8.1.63-11.6 1.09-6 .78-11.3 5.37-17.7 3.8-4.3-1.05-4.1-4.03-4.5-7.86-.1-1.54 3.4-4.57 1.9-4.28-2.8.52-5.4 3.58-8.1 4.47-9.7 3.21-22.2 4.94-32.3 4.36-3.3-.19-9.2-.83-11.7-3.25-1.5-1.48-.6-5.66.3-7.37.6-1.09 3.2-2.23 2.2-2.92-1.2-.85-8.3 1.01-10.6.5-8.7-2-18.7-8.95-23.6-16.14-1.3-2-.7-7.27.1-9.31.3-.67 2.8-2.91 2.5-3.56-.9-1.64-4.9-1.99-6.5-3.05-4.7-3.2-8.9-8.9-7-14.49 2-6.17 8.1-10.66 14.3-11.84 1.2-.23 9.1-.09 9.6-.79.8-1.2-2.1-2.34-2.1-3.79-.1-4.69 5.9-10.09 10.5-9.72 5 .39 12.2 7.46 16.3 10.25 1 .71 10.8 5.05 10.1 6.1-.2.21.4-4.34.5-4.96.6-3 4.1-9.14 8.1-7.56 4.1 1.58 6.3 7.58 9.4 10.42 4.5 4.12 10.4 6.88 15.3 10.36.7.46 4.1 6.5 5.2 6.57 2.3.13 2.4-7.67 5.4-7.26 4.8.64 6.1 5.93 8.1 9.53 7.5 13.4 21.2 19.64 28.3 32.65 1 1.97 4.2 4.06 4.1 4.08"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16046.7 1531.95c0 .09-2.5-2.42-2.8-2.7-1.9-1.92-3.6-3.33-6.1-4.35-7.9-3.17-14.9-8.22-22.6-11.97-22.6-11.11-48.4-18.98-74.2-16.64"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16046.7 1531.95c0 .09-2.5-2.42-2.8-2.7-1.9-1.92-3.6-3.33-6.1-4.35-7.9-3.17-14.9-8.22-22.6-11.97-22.6-11.11-48.4-18.98-74.2-16.64"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15975.9 1509.74c-.5-.63-2 .48-2.6.61-4.6 1.06-24.3 7.93-34.3 6.15"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M15975.9 1509.74c-.5-.63-2 .48-2.6.61-4.6 1.06-24.3 7.93-34.3 6.15"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15995.1 1518.23c-13.6 2.58-16.8 9.64-28.1 10.01Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M15995.1 1518.23c-13.6 2.58-16.8 9.64-28.1 10.01"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16019.1 1527.39c-3.1-1.29-11.6 5.31-14.8 5.86-3.4.57-6.8 1.01-10.1 1.51"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16019.1 1527.39c-3.1-1.29-11.6 5.31-14.8 5.86-3.4.57-6.8 1.01-10.1 1.51"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16007.6 1496.4c-2.3 1.76-3.9-4.34-5.9-6.41-4.1-4.16-8.6-8.16-13.7-10.93"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16007.6 1496.4c-2.3 1.76-3.9-4.34-5.9-6.41-4.1-4.16-8.6-8.16-13.7-10.93"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M15979 1491.39c-6.3-6.13-11.6-11.03-18.4-16.83Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M15979 1491.39c-6.3-6.13-11.6-11.03-18.4-16.83"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16087.5 1535.83c-3.8-8.2-8.6-21.03-6.5-26.4 1.1-2.93 6.5-1.43 6.2-6.66-.2-2.66-6.3-3.8-6.4-3.98-.9-7.8 10.2-4.05 11.7-9.07.3-1.08 1-3.32.4-5.17-.6-1.79-3.1-2-2.6-3.81.9-3.82 7.5-.36 8.4-4.49.3-1.33-.2-5.2-1.5-7.25-1-1.49-3.4-2.3-3.4-2.3s1.3-1.45 2-2.1c1.3-1.24 3.5-4.44 2.5-7.99-2.4-8.74-11.6-23.08-17.9-29.32-2-2.04-6.6-6.67-8.5-7.26-2-.61-3.8.51-6-1.31-2.2-1.71-2.9-5.84-3.8-8.24-1.3-3.38-6.3-7.66-8.2-8.36-3.5-1.25-7.6-2.64-10-1.29-1.1.64-1 5.46-2.6 5.01-1-.29-3-4.32-4.1-5.17-4.3-3.28-6.4.96-7.3 3.96-.8 2.49.3 5.62 2.5 9.11.2.25.7 1.1.6 1.33-.8 2.59-8.1-6.37-7.4-.13.7 6.79 9.6 13.7 10.1 19.02.6 5.82-6.6.51-6.2 4.58.2 2.28 11.2 12.72 12.4 17.54 1.5 6.06-4.4 2.65-3.5 7.47.1.24.2.48.3.71 3.5 4.94 7.6 6.86 11.3 12.54 1.3 1.95 4.9 7.69 4.6 9.5-.3 1.64-2.8.87-1.5 4.22 1.8 4.41 11.1 12.81 14.1 16.82 3.9 5.21 7.9 9.6 11.1 15.72.6 1.21 5.5 11.47 5.7 10.44"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16087.5 1535.83c-3.8-8.2-8.6-21.03-6.5-26.4 1.1-2.93 6.5-1.43 6.2-6.66-.2-2.66-6.3-3.8-6.4-3.98-.9-7.8 10.2-4.05 11.7-9.07.3-1.08 1-3.32.4-5.17-.6-1.79-3.1-2-2.6-3.81.9-3.82 7.5-.36 8.4-4.49.3-1.33-.2-5.2-1.5-7.25-1-1.49-3.4-2.3-3.4-2.3s1.3-1.45 2-2.1c1.3-1.24 3.5-4.44 2.5-7.99-2.4-8.74-11.6-23.08-17.9-29.32-2-2.04-6.6-6.67-8.5-7.26-2-.61-3.8.51-6-1.31-2.2-1.71-2.9-5.84-3.8-8.24-1.3-3.38-6.3-7.66-8.2-8.36-3.5-1.25-7.6-2.64-10-1.29-1.1.64-1 5.46-2.6 5.01-1-.29-3-4.32-4.1-5.17-4.3-3.28-6.4.96-7.3 3.96-.8 2.49.3 5.62 2.5 9.11.2.25.7 1.1.6 1.33-.8 2.59-8.1-6.37-7.4-.13.7 6.79 9.6 13.7 10.1 19.02.6 5.82-6.6.51-6.2 4.58.2 2.28 11.2 12.72 12.4 17.54 1.5 6.06-4.4 2.65-3.5 7.47.1.24.2.48.3.71 3.5 4.94 7.6 6.86 11.3 12.54 1.3 1.95 4.9 7.69 4.6 9.5-.3 1.64-2.8.87-1.5 4.22 1.8 4.41 11.1 12.81 14.1 16.82 3.9 5.21 7.9 9.6 11.1 15.72.6 1.21 5.5 11.47 5.7 10.44"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16075.6 1518.67c-6.4-14.86-8.8-31.29-10.8-44.44-1.7-11.22-3.8-21.43-3.4-31.11.3-5.75-.2-13.87 2.2-17.19"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16075.6 1518.67c-6.4-14.86-8.8-31.29-10.8-44.44-1.7-11.22-3.8-21.43-3.4-31.11.3-5.75-.2-13.87 2.2-17.19"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16073.5 1481.5c3.7-5.69 10.8-7.49 10.9-16.89Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16073.5 1481.5c3.7-5.69 10.8-7.49 10.9-16.89"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16079.8 1465.73c4.5-6.16 11.8-9.68 13.8-18.62Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16079.8 1465.73c4.5-6.16 11.8-9.68 13.8-18.62"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16084.2 1450.29c2.9-4.3 7.1-7.07 10.7-10.45Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16084.2 1450.29c2.9-4.3 7.1-7.07 10.7-10.45"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16069.3 1442.23c-1.8-3.26-6.1-23.25-5.8-25.07Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16069.3 1442.23c-1.8-3.26-6.1-23.25-5.8-25.07"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16057.7 1451.39c-4.6-8.2-5.4-17.66-5.9-24.6Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16057.7 1451.39c-4.6-8.2-5.4-17.66-5.9-24.6"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16046.7 1471.47c-3.4-2.89-5.8-18.39-7-25.04Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16046.7 1471.47c-3.4-2.89-5.8-18.39-7-25.04"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16044.3 1492.99c-1.7-5.09-3.2-11.91-4.7-17.48Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16044.3 1492.99c-1.7-5.09-3.2-11.91-4.7-17.48"
    />
    <path
      fill="#F7F3E1"
      fillRule="evenodd"
      stroke="#F0E9C8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16351.6 1109.91c5.7-5.67-3.4-14.45-10.2-13.89-12.9 1.08-3.7 9.49-5.5 11.37-1 .95-2-1.81-3.2-2.52-1.7-1.07-4.8-1.31-6.5 0-10.2 7.95.4 23.95 8.3 16.03 1.5-1.49-4.2.75-6 1.88-3.4 2.16-6 8.14-3.5 11.67 3.1 4.34 11.5 5.89 16.2 4.4 2.3-.7 5.6-2.89 4.2-5.73-.2-.36-.4-1.15-.4-1.15s-1.4 8.23.6 11.54c1.4 2.38 6.4 2.73 9 2.52 5.3-.45 13.5-8.01 9.7-14.02-.8-1.35-6.4-7.13-8.1-5.43-.2.2 7.6 2.16 8.5 2.23 4.6.35 10.1-5.67 8.5-10.43-1.7-5.08-10.4-13.81-16.1-14.62-2.2-.31-6.5 6.48-5.5 6.15"
      clipRule="evenodd"
    />
    <path
      fill="#F8EC5F"
      fillRule="evenodd"
      stroke="#EFDD0D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.929}
      d="M16346.5 1114.34c1.3.68 1 3.43 2.3 4.51 1.3 1.03 9.7-2.7 6.8 3.54-.7 1.61-3.4-.34-4.2 1.33-.9 1.77 4.1 3.67 1.4 4.73-3.8 1.55-5.4-3.28-7.4-4.27-1-.55-1.5 3.83-3 3.21-2.3-.99-2-3.97-2.7-5.86-.6-1.57-3-2.79-2.8-4.64.3-2.47 4.5 1.63 6.3.76 2.2-1.06 2.2-6.58 3.3-3.31"
      clipRule="evenodd"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16476.6 1429.95c15.7 4.22 32.5 10.8 43.9 23.14 6.5 7.13 9.6 16.72 15.7 24.21 7.3 8.95 17.8 15.08 26.9 21.8 6.2 4.53 12.8 10.96 20.8 11.82 15.6 1.68 30.1-4.67 44.6-9.93 4.2-1.53 10-1.84 14.3-.1.8.31 7.5 3.75 7.8 3.29.2-.38-2.7-2.5-2.9-2.72-3.1-2.59-7.1-4.89-9.9-7.58-1.8-1.76-3.7-4.46-6.3-5.32-1.3-.48-6-.58-6.8-1.69-.4-.56 1.3-3.27 1.4-3.97.2-1.07-1.3-3.92-2.1-4.65-1.7-1.79-5.8-1.86-7-3.82-1.5-2.4 1.3-5.94-.1-8.48-2.9-5.26-11-5.73-14.1-9.76-1.5-1.96 1.5-5.13-.3-7.19-1.6-1.85-5.2-.73-7.3-1.84-3-1.58-2.2-5.72-4.5-7.61-2.3-1.91-6.4-.34-8.7-2.35-1.8-1.57-.1-5.3-1.9-6.47-2.1-1.39-5.7 1.66-7.6-.15-1.5-1.48 1.9-4.62-.3-5.86-2.2-1.33-6.1.75-8.6.36-2.5-.36-3.4-3.09-5.6-3.19-3.1-.14-6.4 2.09-9.4 1.22-1.2-.33-.9-2.29-1.8-2.38-2.5-.25-5.2 3.13-7.9 3.44-2.9.34-3.6-2.76-6.9-2.12-5.7 1.13-10.9 5.73-16.2 8.05-6.1 2.7-13.1 3.46-19.8 3.32-4.6-.1-17.8-1.01-17.8-1.29-.2-.73 11.4.86 12 .69"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16476.6 1429.95c15.7 4.22 32.5 10.8 43.9 23.14 6.5 7.13 9.6 16.72 15.7 24.21 7.3 8.95 17.8 15.08 26.9 21.8 6.2 4.53 12.8 10.96 20.8 11.82 15.6 1.68 30.1-4.67 44.6-9.93 4.2-1.53 10-1.84 14.3-.1.8.31 7.5 3.75 7.8 3.29.2-.38-2.7-2.5-2.9-2.72-3.1-2.59-7.1-4.89-9.9-7.58-1.8-1.76-3.7-4.46-6.3-5.32-1.3-.48-6-.58-6.8-1.69-.4-.56 1.3-3.27 1.4-3.97.2-1.07-1.3-3.92-2.1-4.65-1.7-1.79-5.8-1.86-7-3.82-1.5-2.4 1.3-5.94-.1-8.48-2.9-5.26-11-5.73-14.1-9.76-1.5-1.96 1.5-5.13-.3-7.19-1.6-1.85-5.2-.73-7.3-1.84-3-1.58-2.2-5.72-4.5-7.61-2.3-1.91-6.4-.34-8.7-2.35-1.8-1.57-.1-5.3-1.9-6.47-2.1-1.39-5.7 1.66-7.6-.15-1.5-1.48 1.9-4.62-.3-5.86-2.2-1.33-6.1.75-8.6.36-2.5-.36-3.4-3.09-5.6-3.19-3.1-.14-6.4 2.09-9.4 1.22-1.2-.33-.9-2.29-1.8-2.38-2.5-.25-5.2 3.13-7.9 3.44-2.9.34-3.6-2.76-6.9-2.12-5.7 1.13-10.9 5.73-16.2 8.05-6.1 2.7-13.1 3.46-19.8 3.32-4.6-.1-17.8-1.01-17.8-1.29-.2-.73 11.4.86 12 .69"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16058.2 1530.31c3.4-9.27-3 13.27-3 16.24-.1 4.9 12.3 19.17 4.1 22.96-2.9 1.37-6-3.23-6.1-3.14-1.4 1.05 3.2 3.96 3.8 4.49 2.5 1.91 4.2 6.03 5 8.92.6 2.36 1.6 8.78-.8 10.43-1 .71-4.6 1.31-5.1 1.96-.4.56 4.6 3.95 5.1 4.78 2.5 4.56 3.3 7.98 1.6 13.25-1.5 4.57-5.5-.97-6.6.74-.5.77 3 3.1 3.4 3.48 1.2 1.25 1.1 3.92 1.1 5.58.3 6.24-4.6 2.19-5.6 3.76-.7.98 4.1 4.29-.4 8.66-3 2.98-7.3-6.86-9-4.35-.5.83.8 4.03.8 5.04-.1 3.37-1.4 10.7-4.6 12.74-2.6 1.67-3.9-2.77-5.2-4.2-.5-.62-.5-2.95-1-2.27-2 2.94-3.5 17.36-9.4 16.34-4.7-.82-2.1-11.28-3-11.92-.7-.48-6.4 5.55-9.3 3.06-3.7-3.18 1.4-8.22-1.1-10.79-.6-.6-8.1 4.12-10.2 1.57-3.6-4.13 2-14.41 1.1-19.07-.2-.81-3.7.55-4.5.41-2.2-.41-3.9-2.95-4.5-5.1-2-6.88 5.8-13.26 5.9-19.5 0-2.79-4.9.15-5-4.38-.1-6.79 7.4-11.88 7.8-17.28.1-2.15-5.7-.03-3.8-4.11 2.2-4.64 6.2-12.54 10.4-15.7 1.4-1.11 9.7-4.03 10.1-5.5.5-1.58-7.3-.7-4.1-4.11 5.9-6.14 21.5-3.75 29.2-6.02 5.6-1.63 12-7.77 15.9-12.01"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16058.2 1530.31c3.4-9.27-3 13.27-3 16.24-.1 4.9 12.3 19.17 4.1 22.96-2.9 1.37-6-3.23-6.1-3.14-1.4 1.05 3.2 3.96 3.8 4.49 2.5 1.91 4.2 6.03 5 8.92.6 2.36 1.6 8.78-.8 10.43-1 .71-4.6 1.31-5.1 1.96-.4.56 4.6 3.95 5.1 4.78 2.5 4.56 3.3 7.98 1.6 13.25-1.5 4.57-5.5-.97-6.6.74-.5.77 3 3.1 3.4 3.48 1.2 1.25 1.1 3.92 1.1 5.58.3 6.24-4.6 2.19-5.6 3.76-.7.98 4.1 4.29-.4 8.66-3 2.98-7.3-6.86-9-4.35-.5.83.8 4.03.8 5.04-.1 3.37-1.4 10.7-4.6 12.74-2.6 1.67-3.9-2.77-5.2-4.2-.5-.62-.5-2.95-1-2.27-2 2.94-3.5 17.36-9.4 16.34-4.7-.82-2.1-11.28-3-11.92-.7-.48-6.4 5.55-9.3 3.06-3.7-3.18 1.4-8.22-1.1-10.79-.6-.6-8.1 4.12-10.2 1.57-3.6-4.13 2-14.41 1.1-19.07-.2-.81-3.7.55-4.5.41-2.2-.41-3.9-2.95-4.5-5.1-2-6.88 5.8-13.26 5.9-19.5 0-2.79-4.9.15-5-4.38-.1-6.79 7.4-11.88 7.8-17.28.1-2.15-5.7-.03-3.8-4.11 2.2-4.64 6.2-12.54 10.4-15.7 1.4-1.11 9.7-4.03 10.1-5.5.5-1.58-7.3-.7-4.1-4.11 5.9-6.14 21.5-3.75 29.2-6.02 5.6-1.63 12-7.77 15.9-12.01"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16052.6 1534.47c-1.4.09-2.8 4.38-3.4 5.41-2.9 5.76-6.1 11.29-8.9 17.1-8 16.59-15.3 31.74-16.1 50.69-.4 10.79 4.6 23.28 2.6 33.93"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16052.6 1534.47c-1.4.09-2.8 4.38-3.4 5.41-2.9 5.76-6.1 11.29-8.9 17.1-8 16.59-15.3 31.74-16.1 50.69-.4 10.79 4.6 23.28 2.6 33.93"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16031.8 1612.62c4.2 6.15 8.9 12.81 9.9 20.44Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16031.8 1612.62c4.2 6.15 8.9 12.81 9.9 20.44"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16032.5 1596.88c6.5 7.18 7.9 8.66 11.7 16.23Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16032.5 1596.88c6.5 7.18 7.9 8.66 11.7 16.23"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16039.8 1575.69c5 8.98 9.2 15.98 10.3 26.48Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16039.8 1575.69c5 8.98 9.2 15.98 10.3 26.48"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16045.5 1560.29c4.7 7.22 5.6 10.79 7.1 19.38Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16045.5 1560.29c4.7 7.22 5.6 10.79 7.1 19.38"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16034.4 1551.62c-9.7 4.16-14.9 5.42-21.9 11.75Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16034.4 1551.62c-9.7 4.16-14.9 5.42-21.9 11.75"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16026.5 1565.51c-10.7 7.03-16.9 12.63-18.8 25.05Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16026.5 1565.51c-10.7 7.03-16.9 12.63-18.8 25.05"
    />
    <path
      fill="#80A832"
      fillRule="evenodd"
      d="M16021.9 1584.74c-6.5 9.83-11.4 16.59-13.7 28.59Z"
      clipRule="evenodd"
    />
    <path
      stroke="#6E8F2C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={0.93}
      d="M16021.9 1584.74c-6.5 9.83-11.4 16.59-13.7 28.59"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M16463.5 1837.91c40.9 53.07 153.1 118.23 153.1 118.23s-130.4-61.35-171.3-110.17c-38.1-45.48-129.4-126.29-129.4-126.29s49.2 110.01 73.8 165.03c31.2 69.86 152.3 215.86 152.3 215.86s-156.5-150.47-189.8-220.34c-24.4-51.22-48.9-160.55-48.9-160.55s-10.3 128.47-10.3 192.8c0 66.39 2.4 252.54 2.4 252.54s-17.1-189.4-22.1-252.54c-4.6-57.65 10.2-188.1 10.2-188.1s-25.3 95.85-43.4 142.42c-20.5 52.84-79.7 174.66-79.7 174.66s39.1-135.03 57.2-188.1c17-49.7 51.7-130.32 51.7-130.32s-138.3 90.24-176.7 132.34c-30.9 33.86-108.2 137.71-108.2 137.71s50.8-110.53 81.3-145.1c38.8-44 206-136.37 206-136.37s-100.6 42.74-145.1 60.09c-41.4 16.18-121.6 44.03-121.6 44.03l126.4-61.96s112.4-42.78 137.9-53.28c5.7-2.34 14.2-10 14.2-10h20.5"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.323}
      d="M16404.7 1949.61c-12.9 9.39-27.8 29.8-30 44.22-2.9 19.15-7.1 17.07-10.5 36.99-2 12.04-9.1 25.14-9.1 37.57 0 17.19-8.2 35.52-8.2 53.02 0 2.28-8.2 87.74 1.9 38.84 2.8-13.75 9.7-62.85 15.5-77.59 8.3-21.19 6.6-50.8 18.1-70.51 2.6-4.35 12.1-29.3 16.7-36.97 3.4-5.89 9.7-9.92 14.5-13.99"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M16404.7 1949.61c-12.9 9.39-27.8 29.8-30 44.22-2.9 19.15-7.1 17.07-10.5 36.99-2 12.04-9.1 25.14-9.1 37.57 0 17.19-8.2 35.52-8.2 53.02 0 2.28-8.2 87.74 1.9 38.84 2.8-13.75 9.7-62.85 15.5-77.59 8.3-21.19 6.6-50.8 18.1-70.51 2.6-4.35 12.1-29.3 16.7-36.97 3.4-5.89 9.7-9.92 14.5-13.99"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.323}
      d="M16205.1 1901.01c.4-.32-21 2.03-26 3.53-2.9.86-5.7 1.89-8.3 3.4-16.3 9.77-30.4 22.69-48.5 30.04-11.2 4.5-23 7.06-35.2 6.93-4.8-.05-9.7-.8-14.3-.8-.6 0-23.7-4.04-22.7-3.15 8.6 7.66 37.2 13.72 46.1 14.03 26.9.96 57.7-10.98 77.5-25.92.6-.5 1.2-1.06 1.9-1.55.5-.38 1-.71 1.5-1.06.5-.33 1-.68 1.5-1.01 9.6-5.85 24.6-12.1 24.3-12.35"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M16205.1 1901.01c.4-.32-21 2.03-26 3.53-2.9.86-5.7 1.89-8.3 3.4-16.3 9.77-30.4 22.69-48.5 30.04-11.2 4.5-23 7.06-35.2 6.93-4.8-.05-9.7-.8-14.3-.8-.6 0-23.7-4.04-22.7-3.15 8.6 7.66 37.2 13.72 46.1 14.03 26.9.96 57.7-10.98 77.5-25.92.6-.5 1.2-1.06 1.9-1.55.5-.38 1-.71 1.5-1.06.5-.33 1-.68 1.5-1.01 9.6-5.85 24.6-12.1 24.3-12.35"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.323}
      d="M16490.9 1869.12c2.8-1.63 4.2-4.7 7.3-6.18 16.8-8.21 37.3-8.9 55.2-15.25 14.8-5.25 29.1-13.47 42.7-20.58 11.8-6.18 23.8-13.36 33.9-21.43 8-6.47 36.8-25.15 35-23.39-8.1 8.17-44.5 38.55-49.5 42.47-25.6 20.09-48.9 27.1-79.3 38.6-10.3 3.89-20.6 16.12-28.4 19.08-7.9 2.99-10.2-8.63-14.6-12.98-.6-.61-2.7-.47-2.4-1.23"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M16490.9 1869.12c2.8-1.63 4.2-4.7 7.3-6.18 16.8-8.21 37.3-8.9 55.2-15.25 14.8-5.25 29.1-13.47 42.7-20.58 11.8-6.18 23.8-13.36 33.9-21.43 8-6.47 36.8-25.15 35-23.39-8.1 8.17-44.5 38.55-49.5 42.47-25.6 20.09-48.9 27.1-79.3 38.6-10.3 3.89-20.6 16.12-28.4 19.08-7.9 2.99-10.2-8.63-14.6-12.98-.6-.61-2.7-.47-2.4-1.23"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.323}
      d="M16065.1 1853.87c-6.1 0-17.8 2.84-24.6 3.49-18.3 1.73-38.5-1.94-55.6-7.65-10.3-3.4-20.2-7.17-29.9-11.6-4.1-1.86-7.8-4.31-11.7-6.26-.8-.36-2.3-1.09-2.3-1.09s1.3 1.26 1.8 1.98c4.7 6.32 11.2 12.46 18.4 16.8 17.4 10.47 38.8 19.51 60 22.52 13 1.84 21.5 3.33 33-2.36 6-2.99 1.7-9.41 5-12.97.9-.91 2.1.13 1.4.75"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M16065.1 1853.87c-6.1 0-17.8 2.84-24.6 3.49-18.3 1.73-38.5-1.94-55.6-7.65-10.3-3.4-20.2-7.17-29.9-11.6-4.1-1.86-7.8-4.31-11.7-6.26-.8-.36-2.3-1.09-2.3-1.09s1.3 1.26 1.8 1.98c4.7 6.32 11.2 12.46 18.4 16.8 17.4 10.47 38.8 19.51 60 22.52 13 1.84 21.5 3.33 33-2.36 6-2.99 1.7-9.41 5-12.97.9-.91 2.1.13 1.4.75"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.323}
      d="M16277.7 1935.25c2-1.69-7.7 13.31-8.7 15.62-4.2 8.87-10.5 17.93-15.5 26.6-10.2 17.68-23.2 35.01-37 50.87-5.6 6.43-13.3 11.28-18.6 17.86-6.4 7.84-13.5 14.99-20.7 22.19-2.6 2.5-6.1 6.58-7.3 9.66-.3.66-19 32.2-19 32.2s27.8-35.78 31.2-38.08c11.1-7.5 23.6-22.16 30.9-29.4 24.7-24.54 26.7-34.32 50-59.67 7.1-7.79 14.7-17.22 14.7-27.31 0-3.48 5.1-10.36 5-9.75"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M16277.7 1935.25c2-1.69-7.7 13.31-8.7 15.62-4.2 8.87-10.5 17.93-15.5 26.6-10.2 17.68-23.2 35.01-37 50.87-5.6 6.43-13.3 11.28-18.6 17.86-6.4 7.84-13.5 14.99-20.7 22.19-2.6 2.5-6.1 6.58-7.3 9.66-.3.66-19 32.2-19 32.2s27.8-35.78 31.2-38.08c11.1-7.5 23.6-22.16 30.9-29.4 24.7-24.54 26.7-34.32 50-59.67 7.1-7.79 14.7-17.22 14.7-27.31 0-3.48 5.1-10.36 5-9.75"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.323}
      d="M16425.5 1948.86c-1.4-1.22 3.7 1.38 5.5 2.18 3.5 1.54 7.4 2.02 11 3.36 10.8 4.13 22.8 7.68 34.5 9.88 16 3.03 32.7 3.74 48.9 5.96 13.5 1.86 26.7 5.13 40.1 6.98 5 .67 42.2 10 44.4 10.46 40.7 8.18-46.6-4-51-4.75-15.5-2.6-32-7.77-47.7-8.74-21.3-1.31-45.7 2.59-66.4-2.35-11.1-2.62-15.5-13.94-19.6-21.76-.2-.31-1.1-1.98-1.4-1.98"
    />
    <path
      fill="#65615F"
      fillRule="evenodd"
      d="M16425.5 1948.86c-1.4-1.22 3.7 1.38 5.5 2.18 3.5 1.54 7.4 2.02 11 3.36 10.8 4.13 22.8 7.68 34.5 9.88 16 3.03 32.7 3.74 48.9 5.96 13.5 1.86 26.7 5.13 40.1 6.98 5 .67 42.2 10 44.4 10.46 40.7 8.18-46.6-4-51-4.75-15.5-2.6-32-7.77-47.7-8.74-21.3-1.31-45.7 2.59-66.4-2.35-11.1-2.62-15.5-13.94-19.6-21.76-.2-.31-1.1-1.98-1.4-1.98"
      clipRule="evenodd"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.558}
      d="M16099.3 1774.08c-1-3.34-8.8-3.43-11.3-3.22-11 .9-19.4 8.76-34.9 7.97-20.9-1.09-22.3-10.59-37.4-15.37-12.3-3.91-25.3-.88-37.8.47M16007.8 1859.52c1.5-1.96-2.4-6.79-3.5-8.44-6.5-10.4-22-9.32-28.7-18.18-11.9-15.74-.3-40.46-22.9-51.12M15964 1853.27c-28.4 5.63-20.6 15.41-38.2 25.41-11.7 6.69-24.2 5.06-37.3 6.66M16003.9 1952.32c2.8-4.28-15.7 4.64-19.7 8.74-15.3 15.33-14.4 18.41-38.5 19.79-4.1.24-15.1 1.99-17.2-2.28M16063.7 1891.35c16.1 2.42 27.2 13.32 41.7 17.24 7.9 2.15 25.1-1.6 32.8-3.52M16121.8 1951.18c6.9 1.46 7.9 12.79 5.4 16.97-4.5 7.68-15.6 11.21-20.6 18.85-6.8 10.48-2.5 22.42-3.4 33.72-.4 5.18-2.2 10.09-2.2 15.35M16176.6 1905.34c-5.1-2.89-.5-23.17-3.4-30.52-5.1-13.4-20.6-20.48-33.3-28.57M16195.1 1965.96c11.4 0 19.3 12.33 17.7 21.18-.9 4.54-4.7 8.01-4.9 12.84-.1 4.2 3.6 13.68 10.2 12.97M16179.1 2070.95c2.6-6.05-13.1-9.61-17.1-8.37-5.5 1.72-8.4 6.3-13.2 8.94-16.3 9.01-31.9 11.34-48.8 1.11M16226.7 1836.97c2.2-3.25-11.8-8.42-14.1-8.94-7.7-1.74-14.4 3.27-22.2 2.73-9.8-.7-16.4-7.82-25.2-10.66M16289.6 2018.45c3.7-.79 6.5.71 9.5 2.32 15.2 7.96 7.8 18.7 17.1 27.12 5.9 5.35 15.9 1.39 21.5 8.47M16291.1 2080.59c.4-.12.1-.12-.1-.14-2.7-.26-5.8.52-8.5 1.05-6.5 1.26-14.7 2.95-19 7.66-14.4 15.64-3.5 31.68-35.6 36.27-4.5.63-8.6.4-13-.44M16289.8 1950.2c4.1-3.53 13.3 4.31 16.7 6.53 5 3.26 9.7 7.47 16.2 8.33 13.2 1.76 22.3-7.06 26.7 9.04M16294.6 2132.2c-.1-.11 5.9 2.98 7.4 4.47 3.8 4.02 4.2 8.83 5 13.81.8 5.6-.8 10.85 1.9 16.2 8.4 16.32 15.8 13.79 17.5 31.53M16352.1 2136.23c18.5-7.86 22.5 31.77 28.8 38.39 7.3 7.54 19.7 12.95 25.3 21.37M16361.8 2094.32c12.8-12.21 33.5-9.91 46.5 1.48 6.3 5.49 7.5 15 15.2 19.46 5.9 3.43 24.1 1.14 32.1 2.49M16368 2035.29c-3.7-10.98-17.8-5.45-25-7.6-6.8-2.06-11.8-10.04-17.3-13.85-4.6-3.2-11.5-5.45-14.7-9.84M16390.6 1989.74c3.4-2.21 10.8 3.77 12.6 5.52 8.8 8.58 10 20.72 16.6 30.38 9.6 14 34.2 15.19 48.3 24.87M16353.5 2105.58c.5-.42.2-.55-.3-.87-3.3-1.98-10-3.46-13.5-1.31-14.3 8.73-16.3 9.3-31.1 1.21M16521.9 2079.03c2.6.75 5.4 11.69 4.8 14.62-.8 4.1-3.8 8.18-5.5 12.06-4.8 11.36-4.1 23.37 2.3 34.28M16513.4 2062.8c5.5-4.69 18.5.71 22.9 3.59 7.9 5.14 13.7 12.16 21.4 17.34 8.8 5.84 32.6 8.8 42.9 9.38M16480.2 2029.22c6.2.98 5.5 13.51 4.7 17.01-1.2 5.47-6.7 10.36-9.4 15.43-5.5 10.2-7.3 22.41-5.3 33.44M16475.5 2012.26c6.2-.88 23.2 10.51 31.5 12.13 10.1 2 22 3.58 32.3 2.73 4.9-.4 10.9-3.72 15.5-3.17M16597.7 1987.36c2.7 0 9.2 14.4 9.4 16.56 1.5 14.02-8.4 37.63 11 45.48M16580.7 1981.71c0 2.01.5-1.49.7-1.98 1.2-2.55 4.2-5.45 6.9-6.96 2.3-1.35 5.7-1.17 7.9-2.66 5-3.37.9-15 .2-19.96M16514.8 1971.32c0-15 13-7.59 20.7-18.78 5.1-7.41-.8-16.07 1.8-23.93M16466.1 1965.31c1.9-2.22.6-10.31 2.1-13.54 2.7-5.65 9.7-8.37 12.6-13.75 5.6-10.17-2.4-17.72-6.3-26.65M16492.5 1969.24c6.6.89 20.3 15.36 22.3 21.04 1.3 3.76.3 9.21 2.9 12.4 4.7 5.65 18.9 10.25 25.5 13.96M16586.6 1938.72c4-.31 6.4-6.37 10.7-7.59 12.2-3.44 31.5 7.24 28.9-13.38M16558.3 1922.16c.7 3.48 3.5 17.27 3.8 20.7.4 4.8-3.3 9.22-4.4 13.95-.8 3.85 5.7 11.42 8.1 14.51M16533.9 1906.62c.8 1.38.9-3 1.6-4.4 1.9-3.46 4.4-5.8 8.7-7.06 16.5-4.81 25.2 3.79 35.9-14.55M16522.9 1861.29c6.4-2.9 5.7-15.15 4.2-20.03-2.5-7.81-12.1-13.34-16.9-20-5.2-7.09-4.9-19.03-3-26.93M16580.2 1837.22c2.2-1.54-1.4-5.91-2.5-7.19-5.2-5.85-14-8.71-18.9-14.86-8-9.97-2.9-27.24.4-38.28M16621.9 1814.43c-.6 1.76 6 8.54 7.1 9.85 10.8 12.37 30.5 11.8 47.6 12.77M16564 1851.64c5.8.91 10 13.2 13.9 16.77 8.8 8.14 21.5 11.35 33 15.13M16636 1806.44c.9-.26-2.4-4.36-2.8-4.81-4.4-5.1-11.6-7.37-15.9-12.44-7.2-8.55 3.9-20.06-7.6-27.33"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16553.5 1798.85c.1.36-5.1-7.89-10-8.26-16.9-1.29-22.1 1-31.4-14.76M16560.4 1814.48c.4.61 5-4.98 7.6-5.51 3.7-.74 12.3 2.75 14.7.2M16614.2 1769.52c0-2.54-1-6.65.9-8.84 2.8-3.25 14.1-5.74 10.5-11.26M16610.2 1763.7c.3-1.29-7.1-2.99-8.7-4.74-3.2-3.54-.7-9.32-6.3-10.96"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16608.1 1762.05c3.7-3.91-1-11.24 2.3-15.6M16505.9 1794.33c8-6.78-18-9.76-19.5-15.37"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16505.9 1796.23c3.5-5.88 3.3-18.27-2.6-22.32M16510.9 1824.16c-10.4-8.82-14.7 13.72-33.1 12.71M16526.5 1838.11c9.3-10.49 16.6-7.34 11.5-20.23M16558.8 1778.29c.8 0 .3-5.13-.6-5.65-2.8-1.55-8.3-.35-11.8-2.12M16609.6 1883.54c.6-.44 1 1.67 1 1.73-.6 2.34-1.7 6.11-.7 8.44 2.3 5.08 13.7 8.55 13.7 13.94M16610.9 1883.47c8.6-7.34 25.2 7.45 35.7 6.63M16579.1 1881.8c1.4-1.13-5.4-5.22-6.1-5.67-4.6-2.91-8.7-7.18-7.3-12.37M16567 1892.89c7.9-1.33 16.7 6.22 18.5 12.38.5 1.89-.8 4.45-.1 6.08.4.94 2.7 5.45 3.7 4.93M16548.5 1894.24c1.8 1.01 1-3.54 1.7-5.28 1.6-4.36 2.7-8.57-1.5-12.13M16535.3 1930.44c-1.5-6.2-8.2-5.03-11.5-7.73-5.3-4.26-5.9-10.74-11.1-15.09M16474.4 1911.37c3-7.68 7.7-14.82-1.8-20.49M16474.7 1913.06c-2.9-1.65-7-.57-9.5-2.86-10.1-9-4.7-17.26-22.8-22.04M16471.3 1947.45c1.2-2.12-4.7-6.85-6.3-7.5-4.7-1.83-11.4-.08-16.6-1.58-7.3-2.13-11.1-8.84-16-13.38M16482.8 1933.49c11.4-9.76 19.7 3.6 32.7 3.6M16523.5 1958.81c0-8.96-21.5-4.11-22.6-4.24-3-.34-5.5-2.26-7.7-3.96M16560.1 1948.72c1.6-5.43-8.3-13.26-12.6-15.66M16598.2 1968.89c5.2-6.61 14.8 3.17 20.3 2.59M16585.8 1973.02c.3 0 .3-.24.4-.47.6-6.16-4.8-11.7-9.3-15.82M16605.2 2013.59c.5-.44-.5.57-.7.7-2.2 1.66-5.4 2.34-8.2 2.86-7.5 1.42-15.4 2.59-23.1 3.4M16608.3 2035.02c3.5-2.9 24.7 2.71 32.2-6.96M16617.7 2049.4c-1.4.41-2.4 11.45-2.2 12.71M16618 2047.99c9.9 3.27 20.4 5.67 28.1 12.2M16554.2 2024.34c2.3-7.91 17.1-5.85 10.2-19.29M16556.7 2023.76c8.7 1.3 16 10.01 19.6 16.16M16541.7 2015.41c4.8 4.15 10.4-14.02 14.2-14.82M16514.9 1996.82c.2-.06-3.7-2.51-3.9-2.62-2.2-1.26-5.8-3.03-8.5-2.96-3.8.1-3.8 4.27-6.3 5.95-3.9 2.59-9.8-.37-13.3-2.12M16516.3 2026.85c1.5-2.72 4.9 3.8 5.7 4.71 3.2 3.98 7 18.82 10.9 19.53M16504.4 2023.87c5.2-8.82 6.8-10.41 1.2-18.05M16520.8 2139.93c6.6 0 19.7 21.78 25.9 25.31"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16522.2 2139.62c-2.6 2.26-1.2 10.61-2.3 13.79-.9 2.9-4.2 4.64-6 7.09-4 5.36-5.7 11.56-5.7 17.81M16518 2119.77c.2.48-.5-2.16-1.2-2.96-1.5-1.89-4.1-3.84-6.6-4.64-7.5-2.38-14.4 3.1-20.3-3.9M16523.6 2103.16c3.7 1.56 6.5 4.69 10.2 6.42 6.4 3.05 13.8 5.21 19.9 8.67M16600.2 2093.58c0-6.98 25.3-8.06 31.4-12.83"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16599.3 2093.48c12.6-.72 19.5 29.91 23.5 31.96M16572.8 2089.48c.6-13.45 31.4-15.33 16.5-33.1M16544.6 2074.26c16.8 10.71 2.5 27.86 7.2 40.13M16469.4 2076.78c1.1-1.86-7.2-4.26-7.6-4.34-5-1.07-9.1 1.94-12.8 4.4-11.1 7.49-20.7 3.13-32.8-1.04M16469.5 2095.23c3.6 0 4.2 6.01 4.3 8 .4 10.43-4.8 13.65 4.7 22.72"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16469.5 2095.23c.9 0-1.8 1.1-2.8 1.14-1.7.1-3.9.47-5.7.78-6.9 1.22-10.8 4.69-18.3 4.23M16454.7 2118.35c-1.2-1.98 7.9 6.4 9.2 8.54 5 8.07 0 13.94 10.1 20.2M16455.7 2117.89c3.7-.5 10-2.31 8.3-5.82M16430.1 2117.81c1.1-3.36 10.1 7.45 10.9 8.84 6.2 10.69-1.4 23.03 7.9 33.04M16399.1 2089.62c4.4.62 5.7-6.24 5.5-8.71-.4-7.98-12-12.72-8.3-21.57M16420.4 2026.56c3.1-1.86 4.6 10.03 4.5 10.39-.4 7.36-5.4 13.83-4.2 21.51M16409.3 2007.73c5.7-4.79 21.1 1.72 18.1-9.95M16467.5 2050.33c1.7 0-1.3 4.35-1.8 5.24-1.8 3.52-1.6 6.07 1.5 8.7M16332.8 2107.9c-3.7 1.56-8.7-3.37-9-6.25-1.4-11.49 8.2-14.93-6.8-24.03M16376.2 2164.37c8.9 5.02-4.8 15.33-6.8 19.29-3.1 6.05-.7 12.84.5 18.92M16393.4 2184.2c.2.42 7.6-1.44 11.5-.23 10.4 3.18 18.3 12.3 30 12.3M16368.8 2144.27c1.7-.96.6-1.32 2.8-2.09 13.2-4.49 19.5 10.65 30.9-3.97M16316.1 2177.17c1.2 0-2-.95-3.1-1.34-2.7-1.02-4.5-.52-6.5 1.34-6.8 6.38-13 11.01-23.8 10.25M16306.4 2145.51c6.2-5.34 17.1-6.66 22.6-12.53M16263.5 2089.35c.6-.48 0-2.76.3-3.57 5.1-12.3-6-25.8-17.3-33.54M16249 2115.33c3.9 1.97-13.3 4.18-18.7 2.05-10.9-4.34-13.3-13.1-21.6-19.4M16231 2125.79c-1.6-6.05 14.1 10.65 14.8 14.38 1.9 9.86-12.2 14.38-2.4 23.9M16217.6 2125.79c4.9-5.16-27.2-18.03-31.1-20.08M16217.4 2125.79c1.8 3.05-9.7 3.93-12 5.51-6.2 4.26-11.4 14.02-20.3 8.16M16347.5 1975.53c0-1.86 2.2 3.28 1.3 5.91-1.7 5.17-5 9.6-4.1 15.26.3 1.64 2.9 7.71 6 5.91M16348.1 1974.66c10.4 1.39 15.9 4.07 24.6 10.21M16328.3 1965.58c1.8 0 4.4-2.37 5.7-3.3 16.8-11.96 8.5-16.6 17.2-29.13M16307.3 2003.56c2.6 2.22 6-2.38 6.4-3.9 1.4-5.24 3.6-13.7-2-17.65"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16309.7 2003.59c-3.2 3.2-11.1.2-15-.34M16333.8 2021.21c3-3.85 5.2-10.3 3.4-14.79-1.6-4.11-8-9.28-5.3-13.88M16332.9 2052.61c.9.78-.5 6.86-.4 8.07.4 5.51 4 10.16 6.4 15.15M16212.4 1985.95c3.1-2.61 1.8-6.89 6.4-9.65 5.5-3.37 17.4-3.78 20.8-9.14M16209.9 2005c-14.8 8.35-7.2 12.76-8.6 25.01M16147.5 2072.85c-3.4 4.96-10.5-4.62-11-7.43-.8-4.68 4.8-14.75 1.7-18.18M16115.9 2078.76c2.3 3.44-4.7 10.49-4.9 14.52-.4 7.06 5.3 12.99 7.4 19.53M16099 2073.08c-2.5-7.71-12.7-11.99-21.2-13.28M16098.2 2072.88c-10.6 3.98-21.1 16.75-34.3 11.56M16099.5 2036.52c10.6 3.88 10.6 15.41 11.1 23.86"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M16100.1 2037.22c-8.1 3.11-15.4 9.29-16.9 17.11M16102.1 1999.36c-.2-2.81-6.8.13-9.8 1.21-9.3 3.25-13.7 12.34-22.7 8.06M16112.6 1982.78c3.6-5.02 21.9 7.65 29.8 6.46M16172.3 1886.32c-1-1.58-4.2-3.56-5.8-4.6-12.7-8.54-15.4 14.24-30.1 4.23M16158.9 1859.47c4.2-9.93 26.1-10.67 17.2-25.18M16137.9 1906.66c0-4.94 13.3 1.58 16.5-1.82M16103.5 1906.25c1.7-12.02 10.9-23.5 7.7-35.86M16114.6 1909.81c5.1 1.47 2.7 16.37 2 19.9M16083.5 1898.12c-16.3 9.65-13.9 13.68-12.9 28.3M15989.5 1957.85c-19.1-10.83-5.3-19.69-21.1-30.46M15966.3 1978.48c-9.6-12.7-9.6-33.36-29.1-37.23M15945.6 1981.47c2.9 1.08 1.1 7.53 1.1 9.58 0 8.74-1.1 16.48 6.9 23.27M15927.9 1979.36c-8.4-10.81-2.3-16.44-19.9-20.47"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M15928.3 1978.72s-3.1.24-3.6.3c-2.8.34-5.7 1.23-7.8 2.79-4.9 3.58-6.4 9.95-12.2 12.68M16205.5 1828.99c1.3.27-2.2-1.34-3.1-2.22-1.8-1.98-2.6-3.99-2.3-6.52.9-6.51 5.7-17.36.3-23.06M16174.4 1825.9c.4.64-1.6.3-2.5.37-3.1.23-6.8.24-9.7 1.21-5.5 1.78-5.8 7.61-9.5 10.92M15887.1 1883.84c2 0-3.9-5.68-4.4-5.91-.8-.37-1.2-.49-2.3-.55-11-.56-13.9-5.81-22.5-10.52M15887.5 1885.01c-3.6 3.12-25.8 12.27-33.5 12.27M15921.6 1881.45c.8-2.84 6.1 6.68 6.6 7.84 3.9 9.03-3.6 19.16 7 26.21M15907.1 1883.3c1.3-14.27-.4-14.83-14.4-23.09M15939.6 1863.14c-2.4-9.38-11.3-11.31-19.7-16.41M15966.3 1802.6c.8-1.38-2.7 2.03-4.1 3.03-2.1 1.53-4.1 3.11-6.1 4.77-6.1 5.17-13.7 4.21-21.7 3.76M15973.1 1829.02c17.4-2.48 15.2-6.83 14.8-21.91M15950.6 1781.22c-4.2-10.7-1.3-12.69-12.7-18.54M15951.2 1782.54c1.3-1.15-3.8.53-5.6 1.01-2.9.76-5.7 1.86-8.7 2.65-9.4 2.53-16.9-2.29-24.8-5.81M15974 1764.99c.4-.69 2.2-1.01 2.3-1.27 1.9-6.4-16.9-13.28-22.1-14.29"
    />
    <path
      stroke="#65615F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.243}
      d="M15975.5 1763.92c1.8 6.72-12.6 4.1-20.7 1.82M16020.4 1766.37c1-4.3-9.1-24.63-4.3-28.7M16040.6 1775.41c8.3 9.09-17 13.27-10.9 25.71M16103.7 2005c.6.62 5.9-1.27 7-1.31 4.3-.14 9 1.92 12.8 3.26 6.3 2.17 11.8 11.92 18.6 9.01"
    />
    <path
      fill="#5BB3E5"
      d="M16090 1915.95c0 13.83-11.2 25.05-25 25.05s-25-11.22-25-25.05c0-13.84 25-50.95 25-50.95s25 37.11 25 50.95"
    />
    <path
      fill="#8C8C8C"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={2.88}
      d="m16672.8 1650.85-2 431.13 14.4 38.64 14.7-41.34v-428.43zM16734.7 1650.85l-2 431.13 14.4 38.64 14.7-41.34v-428.43zM16796.4 1650.85l-2.1 431.13 14.4 38.64 14.8-41.34v-428.43z"
      clipRule="evenodd"
    />
    <path fill="#3F4142" d="M16768.2 1324h-40v60h40z" />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M16859.5 1406.36c0-12.39-10-22.45-22.4-22.45h-179.6c-12.4 0-22.5 10.06-22.5 22.45v293c0 12.39 10.1 22.45 22.5 22.45h179.6c12.4 0 22.4-10.06 22.4-22.45z"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M16836.7 1427.41c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16820.2 1417.68h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M16836.7 1469.71c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16820.2 1459.98h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M16836.7 1681.23c0-5.37-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.35-9.7 9.72s4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16820.2 1671.51h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.65 25.4-19.44"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M16836.7 1512.01c0-5.36-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.36-9.7 9.72 0 5.37 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16820.2 1502.29h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.73-9.7 9.73h-32.2c18.4-5.01 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M16836.7 1554.32c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16820.2 1544.59h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M16836.7 1596.62c0-5.36-4.3-9.72-9.7-9.72h-159.5c-5.3 0-9.7 4.36-9.7 9.72 0 5.37 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.35 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16820.2 1586.9h6.8c5.4 0 9.7 4.36 9.7 9.72 0 5.37-4.3 9.73-9.7 9.73h-32.2c18.4-5.01 28.5-11.66 25.4-19.45"
      clipRule="evenodd"
    />
    <path
      fill="#2C6767"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={4.095}
      d="M16836.7 1638.93c0-5.37-4.3-9.73-9.7-9.73h-159.5c-5.3 0-9.7 4.36-9.7 9.73 0 5.36 4.4 9.72 9.7 9.72h159.5c5.4 0 9.7-4.36 9.7-9.72Z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16820.2 1629.2h6.8c5.4 0 9.7 4.36 9.7 9.73 0 5.36-4.3 9.72-9.7 9.72h-32.2c18.4-5 28.5-11.66 25.4-19.45M16693.1 1721.81l-1.5 356.27-6.3 42.54 14.6-41.9v-356.71zM16755.8 1721.81l-1.6 356.27-6.2 42.54 14.6-41.9v-356.71zM16816.7 1721.81l-1.6 356.27-6.2 42.54 14.6-41.9v-356.71z"
      clipRule="evenodd"
    />
    <path
      fill="#5BB3E5"
      d="M15152 3571h668v159h-668zM15908 3674h668v56h-668z"
    />
    <path
      fill="gray"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15387.3 3257.21v658.71l8.6 30.69 27-.66 7.7-30.03v-658.71zM16340.3 3257.21v658.71l-8.6 30.69-27-.66-7.7-30.03v-658.71z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15313.5 3159.54h-65.8v679.23h65.8zM16414.1 3159.54h65.8v679.23h-65.8z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15321.3 3079.31c0-4.61-3.8-8.35-8.4-8.35h-66.8c-4.6 0-8.3 3.74-8.3 8.35v92.4c0 4.61 3.7 8.35 8.3 8.35h66.8c4.6 0 8.4-3.74 8.4-8.35zM16406.3 3079.31c0-4.61 3.8-8.35 8.4-8.35h66.8c4.6 0 8.3 3.74 8.3 8.35v92.4c0 4.61-3.7 8.35-8.3 8.35h-66.8c-4.6 0-8.4-3.74-8.4-8.35z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15321.3 3079.31c0-4.61-3.8-8.35-8.4-8.35h-66.8c-4.6 0-8.3 3.74-8.3 8.35v92.4c0 4.61 3.7 8.35 8.3 8.35h66.8c4.6 0 8.4-3.74 8.4-8.35zM16406.3 3079.31c0-4.61 3.8-8.35 8.4-8.35h66.8c4.6 0 8.3 3.74 8.3 8.35v92.4c0 4.61-3.7 8.35-8.3 8.35h-66.8c-4.6 0-8.4-3.74-8.4-8.35z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15247.7 3180.06v658.71l13.1 30.69 41.1-.66 11.6-30.03v-658.71zM16479.9 3180.06v658.71l-13.1 30.69-41.1-.66-11.6-30.03v-658.71z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={50}
      d="M15705.2 3254.08c-10.7.4-21.3 6.65-30 18.92-18 25.5 0 80.85 0 170.5V3752M16022.4 3254.08c10.7.4 21.3 6.65 30 18.92 18 25.5 0 80.85 0 170.5V3752"
    />
    <path
      stroke="#5BB3E5"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={40}
      d="M15705.2 3254.08c-10.7.4-21.3 6.65-30 18.92-18 25.5 0 80.85 0 170.5V3752M16022.4 3254.08c10.7.4 21.3 6.65 30 18.92 18 25.5 0 80.85 0 170.5V3752"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M15294.7 3072.5v107.56h7l-4.1 653.18-7.7 36.22h13.1l10.5-30.25V3178.5h7.8v-106zM16460.1 3072.5v107.56h7l-4 653.18-7.8 36.22h13.1l10.5-30.25V3178.5h7.8v-106z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15321.3 3079.31c0-4.61-3.8-8.35-8.4-8.35h-66.8c-4.6 0-8.3 3.74-8.3 8.35v92.4c0 4.61 3.7 8.35 8.3 8.35h66.8c4.6 0 8.4-3.74 8.4-8.35zM16406.3 3079.31c0-4.61 3.8-8.35 8.4-8.35h66.8c4.6 0 8.3 3.74 8.3 8.35v92.4c0 4.61-3.7 8.35-8.3 8.35h-66.8c-4.6 0-8.4-3.74-8.4-8.35zM15247.7 3180.06v658.71l13.1 30.69 41.1-.66 11.6-30.03v-658.71zM16479.9 3180.06v658.71l-13.1 30.69-41.1-.66-11.6-30.03v-658.71z"
      clipRule="evenodd"
    />
    <path
      fill="gray"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15430.6 3236.69h-43.3v679.23h43.3zM16297 3236.69h43.3v679.23h-43.3z"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15450.6 3157.01c0-4.91-3.9-8.89-8.8-8.89h-71.2c-4.9 0-8.9 3.98-8.9 8.89v203.05c0 4.91 4 8.89 8.9 8.89h71.2c4.9 0 8.8-3.98 8.8-8.89zM16277 3157.01c0-4.91 3.9-8.89 8.8-8.89h71.2c4.9 0 8.9 3.98 8.9 8.89v203.05c0 4.91-4 8.89-8.9 8.89h-71.2c-4.9 0-8.8-3.98-8.8-8.89z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M15414.4 3150v218.94h5l.7 541.45-5 36.22h8.6l6.9-30.25v-547.42l20.1-6.24V3150z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15450.6 3157.01c0-4.91-3.9-8.89-8.8-8.89h-71.2c-4.9 0-8.9 3.98-8.9 8.89v203.05c0 4.91 4 8.89 8.9 8.89h71.2c4.9 0 8.8-3.98 8.8-8.89z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16328.9 3150v218.94h5l.7 541.45-5 36.22h8.6l6.9-30.25v-547.42l20.1-6.24V3150z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M16277 3157.01c0-4.91 3.9-8.89 8.8-8.89h71.2c4.9 0 8.9 3.98 8.9 8.89v203.05c0 4.91-4 8.89-8.9 8.89h-71.2c-4.9 0-8.8-3.98-8.8-8.89z"
      clipRule="evenodd"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15144 3319.56h681.8v-21.41L15144 3297zM16583.6 3319.56h-681.8v-21.41l681.8-1.15z"
      clipRule="evenodd"
    />
    <path fill="#E2E1E1" fillOpacity={0.85} d="M15819.2 3324h-667v406h667z" />
    <path fill="#595959" fillOpacity={0.2} d="M15820 3324h-78v410h78z" />
    <path fill="#E2E1E1" fillOpacity={0.85} d="M15908.4 3324h667v406h-667z" />
    <path fill="#595959" fillOpacity={0.2} d="M16493 3322h78v404h-78z" />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M16583.6 3729.9h-683.8v133.97l48.4 109.08 155.3 215.15 138.2-1.91 138.2 1.91 155.3-215.15 48.4-109.08z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16491.1 3730v132.5l-33 107-127 215.5h48l154-215.5 48.3-107V3730z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M16583.6 3729.9h-683.8v133.97l48.4 109.08 155.3 215.15 138.2-1.91 138.2 1.91 155.3-215.15 48.4-109.08z"
      clipRule="evenodd"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15144 3729.9h683.8v133.97l-48.4 109.08-155.3 215.15-138.2-1.91-138.2 1.91-155.3-215.15-48.4-109.08z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M15738.2 3730v132.5l-33 107-127 215.5h48l154-215.5 48.3-107V3730z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15144 3729.9h683.8v133.97l-48.4 109.08-155.3 215.15-138.2-1.91-138.2 1.91-155.3-215.15-48.4-109.08z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15765.7 3630.57h38.9v-19.32l-6.9-11.25h-24.5l-7.5 11.25zM15961.9 3630.57h-38.9v-19.32l6.9-11.25h24.5l7.5 11.25zM15708.7 3630.57h38.9v-19.32l-6.9-11.25h-24.5l-7.5 11.25zM16018.9 3630.57h-38.9v-19.32l6.9-11.25h24.5l7.5 11.25z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15819.6 3729.89v-406.27M15908 3729.89v-406.27"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={50}
      d="M15728.2 3628.63c-.1-21.78 0-76.76 0-160.13s27.4-170.5 9.5-195.5c-9.3-12.97-20.9-19.35-32.5-18.92M15999.4 3628.63c.1-21.78 0-76.76 0-160.13s-27.4-170.5-9.5-195.5c9.3-12.97 20.9-19.35 32.5-18.92"
    />
    <path
      stroke="#5BB3E5"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={40}
      d="M15728.2 3628.63c-.1-21.78 0-76.76 0-160.13s27.4-170.5 9.5-195.5c-9.3-12.97-20.9-19.35-32.5-18.92M15999.4 3628.63c.1-21.78 0-76.76 0-160.13s-27.4-170.5-9.5-195.5c9.3-12.97 20.9-19.35 32.5-18.92"
    />
    <path
      fill="#257676"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M16090.2 3730h-461v406h461z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M16035 3756v378.5h56.5V3732h-14.5v24z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M16090.2 3730h-461v406h461z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15737.8 3755.86v27.71h34.8v-27.71h81.8v-125.29H15656v125.29z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15854.4 3620.88h-34.8v134.97h34.8zM15684.1 3620.88h-34.9v134.97h34.9z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15987.6 3755.75v27.71h-34.8v-27.71h-81.8v-125.29h198.4v125.29z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15871 3620.77h34.8v134.98h-34.8zM16041.4 3620.77h34.8v134.98h-34.8z"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M15152.2 3729.89v-406.27M16575.4 3729.89v-406.27"
    />
    <path
      fill="#257676"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m15485.2 3185.66-1 63.22 34.2 48.84h83.1l35.9-55.1-.4-56.67zM16242.4 3185.66l1 63.22-34.2 48.84h-83.1l-35.9-55.1.4-56.67z"
      clipRule="evenodd"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M15614.4 3187.13v54.55l-39.2 56.04h24.8l37.4-56.04v-54.55zM16220.5 3187.13v54.55l-39.3 56.04h24.9l37.3-56.04v-54.55z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="m15485.2 3185.66-1 63.22 34.2 48.84h83.1l35.9-55.1-.4-56.67zM16242.4 3185.66l1 63.22-34.2 48.84h-83.1l-35.9-55.1.4-56.67z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={50}
      d="M15895.7 4249c-.1-21.78 0-419 0-489.5s0-240-58.5-240c-52 0-52 38.5-52 51v55.5"
    />
    <path
      fill="#5BB3E5"
      d="M15875.7 4249.06c0 11.04 9 19.97 20.1 19.94 11-.03 19.9-9.01 19.9-20.06l-20 .06zm20-489.56h-20c0 70.46-.1 467.74 0 489.56l20-.06 20-.06c-.1-21.74 0-418.9 0-489.44zm-58.5-240v20c2.9 0 8.7 1.61 15.8 16.3 6.9 14.18 12 35.13 15.6 60.09 7.1 49.55 7.1 108.12 7.1 143.61h40c0-35.01 0-96.44-7.5-149.27-3.8-26.22-9.6-52.06-19.2-71.86-9.3-19.29-25.5-38.87-51.8-38.87zm0 0v-20c-31.8 0-52.1 12.33-62.8 30.77-9.5 16.36-9.2 34.22-9.2 40.23h40c0-6.49.3-14.13 3.8-20.14 2.3-3.94 8-10.86 28.2-10.86zm-52 51h-20v55.5h40v-55.5z"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={50}
      d="M15832.2 4249c.1-21.78 0-419 0-489.5s0-240 58.5-240c52 0 52 38.5 52 51v55.5"
    />
    <path
      fill="#5BB3E5"
      d="M15852.2 4249.06c0 11.04-9 19.97-20 19.94-11.1-.03-20-9.01-20-20.06l20 .06zm-20-489.56h20c0 70.46.1 467.74 0 489.56l-20-.06-20-.06c.1-21.74 0-418.9 0-489.44zm58.5-240v20c-2.9 0-8.7 1.61-15.8 16.3-6.9 14.18-12 35.13-15.6 60.09-7.1 49.55-7.1 108.12-7.1 143.61h-40c0-35.01 0-96.44 7.5-149.27 3.8-26.22 9.6-52.06 19.2-71.86 9.3-19.29 25.5-38.87 51.8-38.87zm0 0v-20c31.8 0 52.1 12.33 62.8 30.77 9.5 16.36 9.2 34.22 9.2 40.23h-40c0-6.49-.3-14.13-3.8-20.14-2.3-3.94-8-10.86-28.2-10.86zm52 51h20v55.5h-40v-55.5z"
    />
    <path
      stroke="#3F4142"
      strokeWidth={20}
      d="M13630 3931.65c0 120.42 685 120.42 685-984.65"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10.283}
      d="M13471.5 3873.66h-45.1v157.41h45.1zM13854.8 3869.18h-45.1v157.41h45.1z"
    />
    <path fill="#3F4142" d="M13649 3873h-40v60h40z" />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3724.46-100.6 48.63h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13796.5 3724.76 67.1 49.16h62.9l-97.6-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3674.27-100.6 48.63h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13796.5 3674.99 67.1 49.16h62.9l-97.6-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3774.64-100.6 48.63h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13796.5 3774.53 67.1 49.16h62.9l-97.6-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3824.84-100.6 48.62h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13796.5 3824.3 67.1 49.16h62.9l-97.6-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3624.09-100.6 48.62h595.4l-99.1-49.77zM13431.6 3573.89l-100.6 48.63h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13796.5 3575.45 67.1 49.16h62.9l-97.6-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3523.71-100.6 48.62h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13796.5 3525.68 67.1 49.16h62.9l-97.6-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3473.52-100.6 48.63h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13796.5 3475.92 67.1 49.16h62.9l-97.6-49.77zM13796.5 3625.22l67.1 49.16h62.9l-97.6-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13438.8 3373.14-100.6 48.63h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13803.7 3372.61 67.1 49.16h62.8l-97.5-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13438.8 3423.34-100.6 48.62h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m13803.7 3422.38 67.1 49.16h62.8l-97.5-49.77z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={8.614}
      d="m13431.6 3724.46-100.6 48.63h595.4l-99.1-49.77zM13431.6 3674.27l-100.6 48.63h595.4l-99.1-49.77zM13431.6 3774.64l-100.6 48.63h595.4l-99.1-49.77zM13431.6 3824.84l-100.6 48.62h595.4l-99.1-49.77zM13431.6 3624.09l-100.6 48.62h595.4l-99.1-49.77zM13431.6 3573.89l-100.6 48.63h595.4l-99.1-49.77zM13431.6 3523.71l-100.6 48.62h595.4l-99.1-49.77zM13431.6 3473.52l-100.6 48.63h595.4l-99.1-49.77zM13438.8 3373.14l-100.6 48.63h595.4l-99.1-49.77zM13438.8 3423.34l-100.6 48.62h595.4l-99.1-49.77z"
      clipRule="evenodd"
    />
    <path
      fill="#D9D9D9"
      fillOpacity={0.66}
      d="M12660 1083c58.5 0 106 47.46 106 106s-47.5 106-106 106c-5.6 0-11.1-.44-16.5-1.28 50.7-7.92 89.5-51.79 89.5-104.72s-38.8-96.8-89.5-104.72c5.4-.84 10.9-1.28 16.5-1.28"
    />
    <circle cx={12660} cy={1189} r={101} stroke="#3F4142" strokeWidth={10} />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12778 1189h-236v24h236z"
    />
    <path fill="#868686" fillOpacity={0.2} d="M12778 1189h-41v24h41z" />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12778 1189h-236v24h236z"
    />
    <path
      fill="#EDEAE0"
      fillRule="evenodd"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12286 1281v-24.18c79.4-22.08 124.2-31.75 204.6-43.82h328c86.5 10.91 133.8 19.77 214.6 43.82V1281z"
      clipRule="evenodd"
    />
    <path
      fill="#868686"
      fillOpacity={0.2}
      d="m12938.1 1233-127.5-19 168 66.5h54.5V1259z"
    />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12286 1281v-24.18c79.4-22.08 124.2-31.75 204.6-43.82h328c86.5 10.91 133.8 19.77 214.6 43.82V1281z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12829 1281h-339v108h339z"
    />
    <path fill="#868686" fillOpacity={0.2} d="M12824 1281h-53v108h53z" />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12829 1281h-339v108h339z"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12987.2 1389H12331v52.82h656.2z"
    />
    <path fill="#868686" fillOpacity={0.2} d="M12984 1389h-104v48h104z" />
    <path
      stroke="#3F4142"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={10}
      d="M12987.2 1389H12331v52.82h656.2z"
    />
    <path fill="#3F4142" d="M12680 1442h-40v60h40zM15203 1512v-40h60v40z" />
    <path
      fill="#8C8C8C"
      stroke="#3F4142"
      strokeWidth={10}
      d="M15460.4 1426.56h-80.532v132.902h80.532z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M15453.9 1520.79v37.05h-65.9v-37.05z"
      clipRule="evenodd"
    />
    <path
      stroke="#3F4142"
      strokeWidth={10}
      d="M15460.4 1426.56h-80.532v132.902h80.532z"
    />
    <rect
      width={120.994}
      height={162.012}
      x={-5}
      y={5}
      fill="#257676"
      stroke="#3F4142"
      strokeWidth={10}
      rx={15}
      transform="matrix(-1 0 0 1 15383.4 1407)"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M15384.1 1536.67v33.08h-112.4v-33.08z"
      clipRule="evenodd"
    />
    <rect
      width={120.994}
      height={162.012}
      x={-5}
      y={5}
      stroke="#3F4142"
      strokeWidth={10}
      rx={15}
      transform="matrix(-1 0 0 1 15383.4 1407)"
    />
    <mask id="RadSumFig_svg__a" fill="#fff">
      <path d="M15556.1 1576.37v-166.72H15441v166.72z" />
    </mask>
    <path fill="#EDEAE0" d="M15556.1 1576.37v-166.72H15441v166.72z" />
    <path
      fill="#3F4142"
      d="M15556.1 1576.37h10v10h-10zm0-166.72v-10h10v10zm-115.1 0h-10v-10h10zm0 166.72v10h-10v-10zm115.1 0h-10v-166.72h20v166.72zm0-166.72v10H15441v-20h115.1zm-115.1 0h10v166.72h-20v-166.72zm0 166.72v-10h115.1v20H15441z"
      mask="url(#RadSumFig_svg__a)"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m15586.6 1536.67-36.4 33.08h-102.6v-33.08z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeWidth={10}
      d="M15446 1414.64v156.719h180.536V1414.64z"
    />
    <path
      fill="#595959"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="m15574.8 1539.32 11.8 27.78h-139v-27.78z"
      clipRule="evenodd"
    />
    <path
      fill="#EDEAE0"
      stroke="#3F4142"
      strokeWidth={10}
      d="M15547.9 1493c0 43.28 35.1 78.36 78.4 78.36 43.2 0 78.3-35.08 78.3-78.36 0-43.27-35.1-78.36-78.3-78.36-43.3 0-78.4 35.09-78.4 78.36Z"
    />
    <path
      fill="#5BB3E5"
      stroke="#3F4142"
      strokeWidth={10}
      d="M15570.4 1493.01c0 30.02 24.9 54.54 55.9 54.54 30.9 0 55.8-24.52 55.8-54.54s-24.9-54.55-55.8-54.55c-31 .01-55.9 24.53-55.9 54.55Z"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={50}
      d="M15559 3183.5c0-721.08-150.6-1351.62 39.5-1653.5"
    />
    <path
      fill="#5BB3E5"
      d="M15581.6 1519.34c5.9-9.34 18.2-12.15 27.6-6.27 9.3 5.89 12.1 18.24 6.2 27.59l-16.9-10.66zm16.9 10.66 16.9 10.66c-45.2 71.9-70.9 164.57-83.4 275.87-12.4 111.23-11.5 239.61-4.5 382.05 13.7 283.66 51.5 623.92 51.5 984.92h-40c0-360.09-37.5-695.64-51.5-982.98-7-143.07-8-273.99 4.8-388.43 12.8-114.36 39.5-213.71 89.3-292.75z"
    />
    <path
      stroke="#3F4142"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={50}
      d="M16040 1843c-174.9-68.21-309.5-188.71-387.5-305"
    />
    <path
      stroke="#5BB3E5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={1.5}
      strokeWidth={40}
      d="M16040 1843c-174.9-68.21-308-187.21-386-303.5"
    />
    <circle cx={13629} cy={3673} r={383.5} stroke="red" opacity={0} id="a1"/>
    <circle cx={15864} cy={3610} r={792.5} stroke="red" opacity={0} id="a2"/>
    <circle cx={16346} cy={2553} r={247.5} stroke="red" opacity={0} id="a3"/>
    <circle cx={14371} cy={2451} r={609.5} stroke="red" opacity={0} id="a4"/>
    <circle cx={16362} cy={1967} r={225.5} stroke="red" opacity={0} id="a5"/>
    <circle cx={15911} cy={1791} r={177.5} stroke="red" opacity={0} id="a6"/>
    <circle cx={16748} cy={1586} r={247.5} stroke="red" opacity={0} id="a7"/>
    <circle cx={15471} cy={1488} r={277.5} stroke="red" opacity={0} id="a8"/>
    <circle cx={15805} cy={1064} r={231.5} stroke="red" opacity={0} id="a9"/>
    <circle cx={13476} cy={1335} r={465.5} stroke="red" opacity={0} id="a10"/>
    <circle cx={12661} cy={1333} r={353.5} stroke="red" opacity={0} id="a11"/>
  </svg>
);
const ForwardRef = forwardRef(SvgRadSumFig);
export default ForwardRef;

